webpackJsonp([39],{

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_superagent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(66);



var _mutations;





var baseUrl = 'https://wx.dudubashi.com';

var state = {
  home_page_nav: [],
  commuter_sub_nav: [],
  company_list: [],
  home_page_nav_id: null,
  home_page_nav_index: '',
  enterprise_id: null
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["t" /* UPDATE_HOME_PAGE_NAV */], function (state, nav) {
  state.home_page_nav = nav;
  for (var i = 0, len = nav.length; i < len; i++) {
    if (nav[i].id === '1' && nav[i].sub_navs.length > 0) {
      state.commuter_sub_nav = nav[i].sub_navs;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["u" /* UPDATE_CURRENT_HOME_PAGE_NAV_ID */], function (state, id) {
  state.home_page_nav_id = id;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["v" /* UPDATE_CURRENT_HOME_PAGE_NAV_INDEX */], function (state, index) {
  state.home_page_nav_index = index;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* SET_ENTERPRISE_ID */], function (state, id) {
  state.enterprise_id = id;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["x" /* UPDATE_CONFIG_COMPANY_ADDRESS */], function (state, list) {
  state.company_list = list;
}), _mutations);

var actions = {
  getHomePageNav: function getHomePageNav(_ref) {
    var commit = _ref.commit,
        state = _ref.state,
        rootState = _ref.rootState;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(baseUrl + '/index.php/line/enterprise/get_navs').send({
        'enterprise_id': state.enterprise_id
      }).type('form').end(function (err, res) {
        if (err) {
          throw err;
        } else {
          res = JSON.parse(res.text);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["RequestCommonResponse"])({
            'rootState': rootState,
            'res': res,
            successCallback: function successCallback(res) {
              commit('UPDATE_HOME_PAGE_NAV', res.data);
              resolve(res);
            },
            failCallback: function failCallback(res) {
              reject(res);
            }
          });
        }
      });
    });
  },
  getCompanyAddress: function getCompanyAddress(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state,
        rootState = _ref2.rootState;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(baseUrl + '/index.php/line/enterprise/get_address_info').send({
        'enterprise_id': state.enterprise_id
      }).type('form').end(function (err, res) {
        if (err) {
          throw err;
        } else {
          res = JSON.parse(res.text);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["RequestCommonResponse"])({
            'rootState': rootState,
            'res': res,
            successCallback: function successCallback(res) {
              resolve(res);
            },
            failCallback: function failCallback(res) {
              reject(res);
            }
          });
        }
      });
    });
  },
  setCurrentHomeNavId: function setCurrentHomeNavId(_ref3, id) {
    var commit = _ref3.commit;

    commit('UPDATE_CURRENT_HOME_PAGE_NAV_ID', id);
  },
  setEnterpriseId: function setEnterpriseId(_ref4, id) {
    var commit = _ref4.commit;

    commit('SET_ENTERPRISE_ID', id);
  },
  setCurrentHomeNavIdByKey: function setCurrentHomeNavIdByKey(_ref5, nav_id) {
    var commit = _ref5.commit,
        state = _ref5.state;

    for (var i = 0, len = state.home_page_nav.length; i < len; i++) {
      var _nav = state.home_page_nav[i];
      if (_nav.id === nav_id) {
        commit('UPDATE_CURRENT_HOME_PAGE_NAV_ID', _nav.id);
        commit('UPDATE_CURRENT_HOME_PAGE_NAV_INDEX', i);
        if (_nav.sub_navs && _nav.sub_navs.length > 0) {
          state.commuter_sub_nav = _nav.sub_navs;
        }
      }
    }
  },
  wxConfigFun: function wxConfigFun(_ref6, url) {
    var commit = _ref6.commit,
        state = _ref6.state,
        rootState = _ref6.rootState;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var _url = url || window.location.href.split('#')[0];
      if (url && rootState.common && rootState.common.is_wx && !rootState.common.is_android) {}
      __WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(baseUrl + '/index.php/users/weixin/get_wx_sign_package', url).send({
        share_url: encodeURIComponent(_url)
      }).type('form').end(function (err, res) {
        if (err) throw err;
        var _res = void 0;
        if (res.text && res.text.result) {
          _res = JSON.parse(res.text);
        } else {
          _res = JSON.parse(res.xhr.response);
        }
        if (_res && _res.result === '0000') {
          resolve(_res.data);
        } else {
          resolve();
        }
      });
    });
  },
  wxShareConfig: function wxShareConfig(_ref7, data) {
    var commit = _ref7.commit;

    var share_title = data.share_title;
    var share_desc = data.share_desc;
    var share_timeline_title = data.share_timeline_title;
    var share_url = data.share_url || window.location.href;
    var share_img = data.share_img || window.location.origin + '/commuter/dist/static/img/enterprise/43_logo.png';
    window.wx.ready(function () {
      window.wx.onMenuShareTimeline({
        title: share_timeline_title,
        link: share_url,
        imgUrl: share_img,
        success: function success() {},
        cancel: function cancel() {}
      });
      window.wx.onMenuShareAppMessage({
        title: share_title,
        desc: share_desc,
        link: share_url,
        imgUrl: share_img,
        success: function success() {},
        cancel: function cancel() {}
      });
      window.wx.onMenuShareQZone({
        title: share_title,
        link: share_url,
        imgUrl: share_img,
        success: function success() {},
        cancel: function cancel() {}
      });
      window.wx.onMenuShareQQ({
        title: share_title,
        link: share_url,
        imgUrl: share_img,
        success: function success() {},
        cancel: function cancel() {}
      });
      window.wx.onMenuShareWeibo({
        title: share_title,
        link: share_url,
        imgUrl: share_img,
        success: function success() {},
        cancel: function cancel() {}
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: actions,
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/search_logo.ea4ab21.png";

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_flexible_debug_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_flexible_debug_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_js_flexible_debug_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_config__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_userInfo__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_questions__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_common__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_address__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_lineDetail__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_css_reset_css__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_style_css__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_css_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_scss_common_scss__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_scss_common_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_scss_common_scss__);
















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex___default.a.Store({
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    common: __WEBPACK_IMPORTED_MODULE_8__modules_common__["a" /* default */],
    config: __WEBPACK_IMPORTED_MODULE_5__modules_config__["a" /* default */],
    userInfo: __WEBPACK_IMPORTED_MODULE_6__modules_userInfo__["a" /* default */],
    questions: __WEBPACK_IMPORTED_MODULE_7__modules_questions__["a" /* default */],
    address: __WEBPACK_IMPORTED_MODULE_9__modules_address__["a" /* default */],
    lineDetail: __WEBPACK_IMPORTED_MODULE_10__modules_lineDetail__["a" /* default */]
  }
}));

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_superagent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_superagent_jsonp__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_superagent_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_superagent_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_BMap__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_BMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_BMap__);




var _mutations;






var baseUrl = 'https://wx.dudubashi.com';

var state = {
  current_city: '',
  cache_entry_href: '',
  location_city: window.sessionStorage.getItem('location_city') || window.localStorage.getItem('location_city_cache'),
  current_pos: JSON.parse(window.sessionStorage.getItem('current_pos')),
  current_pos_address: '',
  location: {
    commute_start: {},
    commute_end: {},
    feeder_start: {},
    feeder_end: {},
    home: {},
    company: {},
    organize_start: {},
    organize_end: {}
  },
  hot_city_list: [],
  open_city_list: {},
  open_city_name_list: [],
  open_city_name_object: {},
  history_address: window.localStorage.getItem('commute_history_address') ? JSON.parse(window.localStorage.getItem('commute_history_address')) : [],
  show_location_tips: false,
  is_loaded_location: false,
  link_param_cache: '',
  link_param_cache_time: 0,
  cache_check_address: '' };

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* UPDATE_LOCATION_CITY */], function (state, city_name) {
  if (city_name) {
    window.localStorage.setItem('location_city_cache', city_name);
  }
  if (window.localStorage && city_name) {
    window.localStorage.setItem('cacheLocationCity', city_name);
  }
  state.location_city = city_name;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* UPDATE_CHECK_ADDRESS */], function (state, data) {
  state.cache_check_address = data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* UPDATE_CURRENT_CITY */], function (state, city_name) {
  if (city_name) {
    window.localStorage.setItem('location_city_cache', city_name);
  }
  if (window.localStorage && city_name) {
    window.localStorage.setItem('cacheLocationCity', city_name);
  }
  state.current_city = city_name;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* UPDATE_LOCATION */], function (state, params) {
  state.location[params.from] = params.location;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* UPDATE_LOCATION_ADDRESS */], function (state, address) {
  state.current_pos_address = address;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* UPDATE_HOT_CITY_LIST */], function (state, list) {
  state.hot_city_list = list;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* UPDATE_OPEN_CITY_LIST */], function (state, list) {
  state.open_city_list = list;
  var _list = [];
  var _item = {};
  for (var one in list) {
    var city_list = list[one];
    for (var i = 0, len = city_list.length; i < len; i++) {
      _list.push(city_list[i].city_name);
      _item[city_list[i].city_name] = {
        name: city_list[i].city_name,
        id: city_list[i].city_id,
        phone: city_list[i].service_phone
      };
    }
  }
  state.open_city_name_list = _list;
  state.open_city_name_object = _item;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* UPDATE_CURRENT_LOCATION */], function (state, point) {
  state.current_pos = point;
  state.is_loaded_location = true;
  if (window.localStorage && point) {
    window.localStorage.setItem('cacheLocationPoint', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(point));
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* UPDATE_LINK_PARAM_CACHE */], function (state, param) {
  state.link_param_cache = param;
  state.link_param_cache_time = new Date().getTime();
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* UPDATE_HISTORY_ADDRESS */], function (state, data) {
  for (var i = 0, len = state.history_address.length; i < len; i++) {
    var _item = state.history_address[i];
    if (_item.point.lng === data.point.lng && _item.point.lat === data.point.lat || _item.address_title === _item.address_title) {
      state.history_address.splice(i, 1);
      break;
    }
  }
  state.history_address.unshift(data);

  if (state.history_address.length > 10) {
    state.history_address.pop();
  }
  window.localStorage.setItem('commute_history_address', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.history_address));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* UPDATE_LOCATION_TIPS */], function (state, data) {
  state.show_location_tips = data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* UPDATE_IS_LOADED_LOCATION */], function (state, data) {
  state.is_loaded_location = data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* UPDATE_ENTRY_HREF */], function (state, link) {
  state.cache_entry_href = link;
}), _mutations);

var actions = {
  setParamCurrentPos: function setParamCurrentPos(_ref, point) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_4_superagent___default.a.get(window.location.protocol + '//api.map.baidu.com/geocoder/v2/').query({
      output: 'json',
      ak: 'b2tdmZtPCKfwW8iwn5svaT03',
      location: point.lat + ',' + point.lng
    }).set('Accept', 'application/json').use(__WEBPACK_IMPORTED_MODULE_6_superagent_jsonp___default.a).end(function (err, res) {
      if (err) {} else {
        if (res.body.status === 0) {
          res = res.body.result;
          res.addressComponent = res.addressComponent || {};
          commit('UPDATE_LOCATION_CITY', res.addressComponent.city);
          var _location = {
            is_current_pos: true
          };
          if (res.formatted_address && res.addressComponent.city && res.addressComponent.province) {
            _location.address = res.formatted_address;
            _location.city = res.addressComponent.city;
            _location.province = res.addressComponent.province;
            if (res.sematic_description) {
              _location.address_title = res.sematic_description;
            } else {
              var _address_title = _location.address.replace(res.addressComponent.province, '');
              _address_title = _address_title.replace(res.addressComponent.city, '');
              _location.address_title = _address_title;
            }
            _location.point = res.location;
            if (_location.point) {
              _location.associate_location = _location.point.lng + ',' + _location.point.lat;
            }

            commit('UPDATE_LOCATION', {
              from: 'commute_start',
              location: _location
            });
            commit('UPDATE_LOCATION_ADDRESS', _location.address || '');
          }
          commit('UPDATE_CURRENT_LOCATION', point);
        }
      }
    });
  },
  getCurrentCity: function getCurrentCity(_ref2, show_tips) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var geolocation = new __WEBPACK_IMPORTED_MODULE_7_BMap___default.a.Geolocation();
    var geoc = new __WEBPACK_IMPORTED_MODULE_7_BMap___default.a.Geocoder();

    geolocation.getCurrentPosition(function (result) {
      var _status = this.getStatus();
      if (_status === window.BMAP_STATUS_SUCCESS) {
        geoc.getLocation(result.point, function (res) {
          res.addressComponents = res.addressComponents || {};

          commit('UPDATE_LOCATION_CITY', res.addressComponents.city || '');
          commit('UPDATE_CURRENT_LOCATION', res.point);

          if (!state.location.commute_start.address_title) {
            var address_title = res.address;
            address_title = address_title.replace(res.addressComponents.city, '');
            address_title = address_title.replace(res.addressComponents.province, '');
            var _location = {
              city: res.addressComponents.city,
              province: res.addressComponents.province,
              point: res.point,
              address_title: address_title,
              is_current_pos: true
            };
            if (res.point) {
              _location.associate_location = res.point.lng + ',' + res.point.lat;
            }
            commit('UPDATE_LOCATION', {
              from: 'commute_start',
              location: _location
            });
          }
          if (show_tips) {
            commit('UPDATE_LOCATION_TIPS', true);
          }
        });
      } else {
        if (!window.localStorage.getItem('location_city_cache')) {
          window.alert('定位失败：' + _status);
        }
        if (show_tips) {
          commit('UPDATE_LOCATION_TIPS', true);
        }
      }
    }, function () {
      if (show_tips) {
        commit('UPDATE_LOCATION_TIPS', true);
      }
    }, {
      enableHighAccuracy: true
    });
  },
  getCityPoint: function getCityPoint(_ref3, city) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var _city = city + '';
    if (_city.indexOf('市') === -1) {
      _city = _city + '市';
    }
    var geoc = new __WEBPACK_IMPORTED_MODULE_7_BMap___default.a.Geocoder();
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      geoc.getPoint(_city, function (point) {
        if (point) {
          commit('UPDATE_CURRENT_LOCATION', point);
        } else {}
        resolve(point);
      });
    });
  },
  searchAddress: function searchAddress(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var _city = params.city ? params.city : state.current_city || state.location_city;
    if (params.keyword.length > 0) {
      var _param = {
        ak: 'b2tdmZtPCKfwW8iwn5svaT03',
        region: _city,
        output: 'json',
        query: params.keyword
      };
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4_superagent___default.a.get(window.location.protocol + '//api.map.baidu.com/place/v2/suggestion').query(_param).set('Accept', 'application/json').use(__WEBPACK_IMPORTED_MODULE_6_superagent_jsonp___default.a).end(function (err, res) {
          if (err) {} else {
            var _arr = [];
            for (var i = 0, len = res.body.result.length; i < len; i++) {
              var _place = res.body.result[i];
              if (_place.location) {
                _arr.push({
                  address_title: _place.name,
                  point: _place.location
                });
              }
            }
            resolve(_arr);
          }
        });
      });
    }
  },
  geocoder: function geocoder(_ref5, arr) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var _promise_arr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
      var _p = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4_superagent___default.a.get(window.location.protocol + '//api.map.baidu.com/geocoder/v2/').query({
          output: 'json',
          ak: 'b2tdmZtPCKfwW8iwn5svaT03',
          location: arr[i].point.lat + ',' + arr[i].point.lng
        }).set('Accept', 'application/json').use(__WEBPACK_IMPORTED_MODULE_6_superagent_jsonp___default.a).end(function (err, res) {
          if (err) {} else {
            resolve(res);
          }
        });
      });
      _promise_arr.push(_p);
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(_promise_arr);
  },
  setAddress: function setAddress(_ref6, params) {
    var commit = _ref6.commit,
        state = _ref6.state;

    commit('UPDATE_LOCATION', params);
    if (params.location.associate_address && !params.no_history) {
      commit('UPDATE_HISTORY_ADDRESS', params.location);
    }
  },
  addHistoryAddress: function addHistoryAddress(_ref7, params) {
    var commit = _ref7.commit,
        state = _ref7.state;

    commit('UPDATE_HISTORY_ADDRESS', params.location);
  },
  setCacheAddress: function setCacheAddress(_ref8, params) {
    var commit = _ref8.commit,
        state = _ref8.state;

    commit('UPDATE_CHECK_ADDRESS', params);
  },
  getHotCity: function getHotCity(_ref9) {
    var commit = _ref9.commit,
        state = _ref9.state;

    __WEBPACK_IMPORTED_MODULE_4_superagent___default.a.post(baseUrl + '/index.php/home/city/get_bus_hot_city').end(function (err, res) {
      if (err) throw err;
      var _data = JSON.parse(res.text);
      if (_data.result === '0000') {
        commit('UPDATE_HOT_CITY_LIST', _data.data);
      }
    });
  },
  getOpenCity: function getOpenCity(_ref10) {
    var commit = _ref10.commit,
        state = _ref10.state;

    __WEBPACK_IMPORTED_MODULE_4_superagent___default.a.post(baseUrl + '/index.php/line/enterprise/get_open_citys').send({
      enterprise_id: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].state.enterprise_id
    }).type('form').end(function (err, res) {
      if (err) throw err;
      var _data = JSON.parse(res.text);
      if (_data.result === '0000') {
        commit('UPDATE_OPEN_CITY_LIST', _data.data);
      }
    });
  },
  setCurrentCity: function setCurrentCity(_ref11, city_name) {
    var commit = _ref11.commit,
        state = _ref11.state;

    commit('UPDATE_CURRENT_CITY', city_name);
  },
  setLoadedLocation: function setLoadedLocation(_ref12, status) {
    var commit = _ref12.commit,
        state = _ref12.state;

    commit('UPDATE_IS_LOADED_LOCATION', status);
  },
  exchangeLocation: function exchangeLocation(_ref13, callback) {
    var commit = _ref13.commit,
        state = _ref13.state;

    var _start = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.location.commute_start || {}));
    var _end = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.location.commute_end || {}));

    commit('UPDATE_LOCATION', {
      from: 'commute_start',
      location: _end
    });
    commit('UPDATE_LOCATION', {
      from: 'commute_end',
      location: _start
    });
    if (callback) {
      callback();
    }
  },
  setCompanyAddress: function setCompanyAddress(_ref14, location) {
    var commit = _ref14.commit;

    commit('UPDATE_LOCATION', {
      from: 'organize_end',
      location: location
    });
  },
  getWXLocation: function getWXLocation(_ref15) {
    var commit = _ref15.commit;

    var convertor = new __WEBPACK_IMPORTED_MODULE_7_BMap___default.a.Convertor();
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      window.wx.ready(function () {
        window.wx.getLocation({
          type: 'gcj02',
          success: function success(res) {
            var lat = res.latitude;
            var lng = res.longitude;
            convertor.translate([new __WEBPACK_IMPORTED_MODULE_7_BMap___default.a.Point(lng, lat)], 3, 5, function (data) {
              if (data.status === 0) {
                resolve(data.points[0]);
              }
            });
          },
          cancel: function cancel(res) {
            reject('用户拒绝授权获取地理位置');
          },
          fail: function fail(res) {
            reject(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(res));
          }
        });
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: actions,
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_superagent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__address__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__userInfo__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(66);




var _mutations;







var baseUrl = 'https://wx.dudubashi.com';

var state = {
  user_id: null,
  user_phone: null,
  user_avatar: null,
  user_nickname: null,
  user_base_info: {}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["n" /* UPDATE_USER_NICKNAME */], function (state, nickname) {
  state.user_nickname = nickname;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* UPDATE_USER_ID */], function (state, user_id) {
  state.user_id = user_id;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["p" /* UPDATE_USER_PHONE */], function (state, user_phone) {
  state.user_phone = user_phone;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["q" /* UPDATE_USER_AVATAR */], function (state, user_avatar) {
  state.user_avatar = user_avatar;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["r" /* SET_USER_TOKEN */], function (state, token) {
  state.token = token;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["s" /* UPDATE_USER_BASE_INFO */], function (context, data) {
  state.user_base_info = data;
}), _mutations);

var actions = {
  setUserInfo: function setUserInfo(_ref, params) {
    var commit = _ref.commit;

    commit('UPDATE_USER_ID', params.user_id ? params.user_id : '');
    commit('UPDATE_USER_PHONE', params.mobile ? params.mobile : '');
    commit('SET_USER_TOKEN', params.token ? params.token : '');
  },
  getCode: function getCode(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state,
        rootState = _ref2.rootState;

    if (__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].state.enterprise_id) {
      params.enterprise_id = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].state.enterprise_id;
    }
    if (params) {
      params.channel = '2';
    }
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_superagent___default.a.post(baseUrl + '/index.php/sms/code/send_new').send(params).type('form').end(function (err, res) {
        if (err) {
          throw err;
        } else {
          res = JSON.parse(res.text);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions__["RequestCommonResponse"])({
            'rootState': rootState,
            'res': res,
            successCallback: function successCallback(res) {
              resolve(res);
            },
            failCallback: function failCallback(res) {
              reject(res);
            }
          });
        }
      });
    });
  },
  userLogin: function userLogin(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state,
        rootState = _ref3.rootState;

    if (__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].state.enterprise_id) {
      params.enterprise_id = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].state.enterprise_id;
    }
    if (__WEBPACK_IMPORTED_MODULE_7__userInfo__["a" /* default */].state.user_id) {
      params.user_id = __WEBPACK_IMPORTED_MODULE_7__userInfo__["a" /* default */].state.user_id;
    }
    if (params) {
      params.login_type = '1';
    }
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_superagent___default.a.post(baseUrl + '/index.php/users/login/login_new').set('Accept', 'application/json').send(params).type('form').end(function (err, res) {
        if (err) {
          throw err;
        } else {
          res = JSON.parse(res.text);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions__["RequestCommonResponse"])({
            'rootState': rootState,
            'res': res,
            successCallback: function successCallback(res) {
              resolve(res);
            },
            failCallback: function failCallback(res) {
              reject(res);
            }
          });
        }
      });
    });
  },
  userLogout: function userLogout(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state,
        rootState = _ref4.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_superagent___default.a.post(baseUrl + '/index.php/users/mine/login_out').set('Accept', 'application/json').send(params).type('form').end(function (err, res) {
        if (err) {
          throw err;
        } else {
          res = JSON.parse(res.text);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions__["RequestCommonResponse"])({
            'rootState': rootState,
            'res': res,
            successCallback: function successCallback(res) {
              resolve(res);
            },
            failCallback: function failCallback(res) {
              reject(res);
            }
          });
        }
      });
    });
  },
  autoLogin: function autoLogin(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state,
        rootState = _ref5.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_superagent___default.a.post(baseUrl + '/index.php/users/mine/auto_login').type('form').end(function (err, res) {
        if (err) {
          throw err;
        } else {
          res = JSON.parse(res.text);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions__["RequestCommonResponse"])({
            'rootState': rootState,
            'res': res,
            successCallback: function successCallback(res) {
              commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* UPDATE_USER_ID */], res.data.ltb_user_id);
              commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["p" /* UPDATE_USER_PHONE */], res.data.user_name);
              commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["q" /* UPDATE_USER_AVATAR */], res.data.user_head_img);
              commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["n" /* UPDATE_USER_NICKNAME */], res.data.user_nick);

              resolve(res);
            },
            failCallback: function failCallback(res) {
              reject(res);
            }
          });
        }
      });
    });
  },
  getUserInfo: function getUserInfo(context, callback) {
    if (state.user_base_info.ltb_user_id) {
      if (callback) {
        callback(true);
      }
      return;
    }
    __WEBPACK_IMPORTED_MODULE_4_superagent___default.a.post(baseUrl + '/index.php/api/v1/getUserInfo').send({
      key: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        userID: state.user_id
      })
    }).type('form').end(function (err, res) {
      if (err) throw err;
      var _data = JSON.parse(res.text);
      if (_data.result === '1') {
        context.commit('UPDATE_USER_BASE_INFO', _data.data);
        if (_data.data.company_place) {
          context.commit('UPDATE_LOCATION', {
            from: 'company',
            location: {
              address_title: _data.data.company_place,
              point: {
                lat: _data.data.company_lat,
                lng: _data.data.company_lng
              }
            }
          }, { root: true });
        }
        if (_data.data.company_place) {
          context.commit('UPDATE_LOCATION', {
            from: 'home',
            location: {
              address_title: _data.data.home_place,
              point: {
                lat: _data.data.company_lat,
                lng: _data.data.company_lng
              }
            }
          }, { root: true });
        }
        if (callback) {
          callback(true);
        }
      } else {
        if (callback) {
          callback(false);
        }
      }
    });
  },
  saveUserInfo: function saveUserInfo(_ref6, params) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      params.company = __WEBPACK_IMPORTED_MODULE_5__address__["a" /* default */].state.location.company.address_title;
      params.compLng = __WEBPACK_IMPORTED_MODULE_5__address__["a" /* default */].state.location.company.point.lng;
      params.companyLat = __WEBPACK_IMPORTED_MODULE_5__address__["a" /* default */].state.location.company.point.lat;
      params.home = __WEBPACK_IMPORTED_MODULE_5__address__["a" /* default */].state.location.home.address_title;
      params.homeLng = __WEBPACK_IMPORTED_MODULE_5__address__["a" /* default */].state.location.home.point.lng;
      params.homeLat = __WEBPACK_IMPORTED_MODULE_5__address__["a" /* default */].state.location.home.point.lat;
      params.userID = state.user_id;
      if (__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].state.enterprise_id) {
        params.enterprise_id = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].state.enterprise_id;
      }
      __WEBPACK_IMPORTED_MODULE_4_superagent___default.a.post(baseUrl + '/index.php/api/v1/updateUserInfo').send({
        key: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
      }).type('form').end(function (err, res) {
        if (err) throw err;
        var _data = JSON.parse(res.text);
        if (_data.result === '1') {
          resolve(_data.info);
        } else {
          reject(_data.info);
        }
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions,
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Enterprise__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Enterprise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Enterprise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Index__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_index__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_wx_config_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_util_js__ = __webpack_require__(56);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  base: '/commuter/dist',
  mode: 'history',
  routes: [{
    path: '/home',
    name: 'home',
    alias: '/',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Index___default.a,
    meta: {
      need_login: false
    }
  }, {
    path: '/e/:enterprise_id',
    name: 'enterprise',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Enterprise___default.a,
    meta: {
      need_login: false
    },
    children: [{
      path: '',
      name: 'index',
      component: __WEBPACK_IMPORTED_MODULE_4__pages_Index___default.a,
      meta: {
        keep_alive: true,
        need_login: false
      }
    }, {
      path: 'commute/:id',
      name: 'index',
      component: __WEBPACK_IMPORTED_MODULE_4__pages_Index___default.a,
      meta: {
        keep_alive: true,
        need_login: false
      }
    }, {
      path: 'wechatGroup',
      name: 'wechatGroup',
      component: function component(resolve) {
        __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(553)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '加入群聊',
        need_login: false
      }
    }, {
      path: 'customLine',
      name: 'customLine',
      component: function component(resolve) {
        __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(522)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '定制开通',
        need_login: true
      }
    }, {
      path: 'collectLine',
      name: 'collectLine',
      component: function component(resolve) {
        __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(521)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '我的收藏',
        need_login: true
      }
    }, {
      path: 'unopenLine/:line_id',
      name: 'unopenLine',
      component: function component(resolve) {
        __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(550)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '查看线路',
        need_login: false
      }
    }, {
      path: 'organizeLineSuccess/:line_id',
      name: 'organizeLineSuccess',
      component: function component(resolve) {
        __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(537)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '提交成功',
        need_login: true
      }
    }, {
      path: 'organizeLine',
      name: 'organizeLine',
      component: function component(resolve) {
        __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(536)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '发起线路',
        need_login: true
      }
    }, {
      path: 'setAddress/:from',
      name: 'setAddress',
      component: function component(resolve) {
        __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(548)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '地址查询',
        need_login: false
      }
    }, {
      path: 'checkAddress/:from',
      name: 'checkAddress',
      component: function component(resolve) {
        __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(519)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '设置地址',
        need_login: false
      }
    }, {
      path: 'selectCity',
      name: 'selectCity',
      component: function component(resolve) {
        __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(547)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '选择城市',
        need_login: false
      }
    }, {
      path: 'searchResult',
      name: 'searchResult',
      component: function component(resolve) {
        __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(545)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        keep_alive: true,
        title: '搜索结果',
        need_login: false
      }
    }, {
      path: 'searchResultOpt',
      name: 'searchResultOpt',
      component: function component(resolve) {
        __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(546)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        keep_alive: true,
        title: '搜索结果',
        need_login: false
      }
    }, {
      path: 'lineDetail/:line_id',
      name: 'lineDetail',
      component: function component(resolve) {
        __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(528)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '班次详情',
        need_login: false,
        need_init_wx: true
      }
    }, {
      path: 'mapDirection',
      name: 'mapDirection',
      component: function component(resolve) {
        __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(554)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '线路导航',
        need_login: false,
        need_init_wx: true
      }
    }, {
      path: 'bug/:line_id',
      name: 'bug_ticket',
      component: function component(resolve) {
        __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(518)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '购买车票',
        need_login: true,
        keep_alive: true
      }
    }, {
      path: 'pay',
      name: 'pay_detal',
      component: function component(resolve) {
        __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(538)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '支付页面',
        need_login: true
      }
    }, {
      path: 'paySuccess',
      name: 'pay_success',
      component: function component(resolve) {
        __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(539)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '支付成功',
        need_login: false
      }
    }, {
      path: 'refundTicketRule',
      name: 'refund_ticket_rule',
      component: function component(resolve) {
        __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(542)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '退票规则',
        need_login: false
      }
    }, {
      path: 'lineDetailToBuy/:line_id',
      name: 'lineDetailToBuy',
      component: function component(resolve) {
        __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(529)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '班次详情',
        need_login: false,
        need_init_wx: true
      }
    }, {
      path: 'usefulTicket',
      name: 'useful_ticket',
      component: function component(resolve) {
        __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(551)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '当天可验车票',
        need_login: true,
        need_init_wx: true
      }
    }, {
      path: 'checkedRecord',
      name: 'checked_record',
      component: function component(resolve) {
        __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(520)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '验票记录',
        need_login: true
      }
    }, {
      path: 'questions',
      name: 'questions',
      component: function component(resolve) {
        __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(540)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '热门咨询',
        need_login: false
      }
    }, {
      path: 'sitePanorama',
      name: 'sitePanorama',
      component: function component(resolve) {
        __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(549)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '站点描述',
        need_login: false
      }
    }, {
      path: 'feedback',
      name: 'feedback',
      component: function component(resolve) {
        __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(524)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '问题反馈',
        need_login: true
      }
    }, {
      path: 'feedbackEnt',
      name: 'feedbackEnt',
      component: function component(resolve) {
        __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(526)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '线路反馈',
        need_login: true
      }
    }, {
      path: 'searchLine',
      name: 'searchLine',
      component: function component(resolve) {
        __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(543)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '线路搜索',
        need_login: false
      }
    }, {
      path: 'searchMap',
      name: 'searchMap',
      component: function component(resolve) {
        __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(544)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '位置选择',
        need_login: false
      }
    }, {
      path: 'feedbackSend',
      name: 'feedbackSend',
      component: function component(resolve) {
        __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(527)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '线路反馈',
        need_login: true,
        keep_alive: true
      }
    }, {
      name: 'rater',
      path: 'rater',
      component: function component(resolve) {
        __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(541)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '评价',
        need_login: true
      }
    }, {
      path: 'userInfo',
      name: 'userInfo',
      component: function component(resolve) {
        __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(552)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '个人信息',
        need_login: true
      }
    }, {
      path: 'myMessage',
      name: 'myMessage',
      component: function component(resolve) {
        __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(532)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '我的消息',
        need_login: true
      }
    }, {
      path: 'myOrder',
      name: 'myOrder',
      component: function component(resolve) {
        __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(533)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '我的订单',
        need_login: true
      }
    }, {
      path: 'orderDetail/:orderNumber',
      name: 'order_detail',
      component: function component(resolve) {
        __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(535)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '订单详情',
        need_login: true
      }
    }, {
      path: 'messageDetail/:message_id',
      name: 'messageDetail',
      component: function component(resolve) {
        __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(531)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        need_login: false
      }
    }, {
      path: 'feedbackDetail/:message_id',
      name: 'feedbackDetail',
      component: function component(resolve) {
        __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(525)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '反馈详情',
        need_login: true
      }
    }, {
      path: 'evaluateDetail/:message_id',
      name: 'evaluateDetail',
      component: function component(resolve) {
        __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(523)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '评价详情',
        need_login: true
      }
    }, {
      path: 'notice/:notice_id',
      name: 'notice',
      component: function component(resolve) {
        __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(534)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '公告信息',
        need_login: false
      }
    }, {
      path: 'login',
      name: 'login',
      component: function component(resolve) {
        __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(530)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '登录',
        need_login: false
      }
    }, {
      path: 'help',
      name: 'help',
      component: function component(resolve) {
        __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(143)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '帮助与反馈',
        need_login: false
      },
      children: [{
        path: ':categroy_id',
        name: 'help',
        component: function component(resolve) {
          __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(143)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
          title: '帮助与反馈',
          need_login: false
        }
      }, {
        path: ':categroy_id/:question_id',
        name: 'help',
        component: function component(resolve) {
          __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(143)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
          title: '帮助与反馈',
          need_login: false
        }
      }]
    }]
  }]
});

var init_base = false;
var init_login = false;
var set_enterprise_id = false;
var init_wx = false;
var init_wx_status = false;
var get_enterprise_nav = false;

window.reportEvent = function (text) {
  if (window.location.origin === 'https://wx.dudubashi.com') {
    console.log('tdapp上报123');
    try {
      if (TDAPP && TDAPP.onEvent) {
        TDAPP.onEvent(text);
      }
    } catch (e) {}
  }
};

__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].commit('UPDATE_ENTRY_HREF', location.href.split('#')[0]);
router.beforeEach(function (to, from, next) {
  if (to.path === '/e/43/commute/' || to.path === '/e/43/commute') {
    goNext({
      path: '/e/43/',
      query: to.query
    });
  } else if (__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.link_param_cache && !to.query.lng) {
    var cacheQuery = to.query;
    cacheQuery.lng = __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.link_param_cache.lng || '';
    cacheQuery.lat = __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.link_param_cache.lat || '';
    cacheQuery.city_name = __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.link_param_cache.city_name || '';
    goNext({
      path: to.path,
      query: cacheQuery || {}
    });
  } else {
    if (!set_enterprise_id && to.params.enterprise_id) {
      __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('setEnterpriseId', to.params.enterprise_id);
      set_enterprise_id = true;
    }

    if (__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.is_login) {
      goNext();
    } else {
      if (!init_login) {
        init_login = true;

        var _result = __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('autoLogin');
        _result.then(function (_res) {
          if (to.meta.need_login) {
            if (!_res.data.login) {
              var path = '/login?from=' + encodeURIComponent(to.fullPath);
              if (__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.enterprise_id) {
                path = '/e/' + __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.enterprise_id + path;
              }
              goNext({ path: path });
            } else {
              goNext();
            }
          } else {
            goNext();
          }
        });
      } else {
        if (to.meta.need_login) {
          var path = '/login?from=' + encodeURIComponent(to.fullPath);
          if (__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.enterprise_id) {
            path = '/e/' + __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.enterprise_id + path;
          }
          goNext({ path: path });
        } else {
          goNext();
        }
      }
    }
  }
  function goNext(param) {
    if (!get_enterprise_nav && to.params.enterprise_id) {
      get_enterprise_nav = true;
      __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('getHomePageNav');
    }
    if (param) {
      next(param);
    } else {
      next();
    }
  }
});

router.afterEach(function (to, from) {
  __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].commit('UPDATE_BACK_PATH', to.path !== '/' ? from.path : '');
  if (from.path) {
    __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].commit('UPDATE_PAGE_FROM', from.path);
  }
  var url = window.location.href;

  var _hash = window.location.hash || '';
  if (_hash) {
    url = url.replace(_hash, '');
  }
  if (!init_base) {
    init_base = true;
    if (to.query.lng || to.query.city_name) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__assets_js_util_js__["b" /* postCnzzData */])('9.2.1 渠道来源new', 'iadmin');
    } else {
      if (__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.is_wx) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__assets_js_util_js__["b" /* postCnzzData */])('9.2.1 渠道来源new', '微信');
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__assets_js_util_js__["b" /* postCnzzData */])('9.2.1 渠道来源new', '其他');
      }
    }
    if (!__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.current_pos) {
      if (!__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.link_param_cache && to.query.lng) {
        __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].commit('UPDATE_LINK_PARAM_CACHE', to.query);
        __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('setParamCurrentPos', {
          lng: to.query.lng,
          lat: to.query.lat
        });
        if (to.query.city_name) {
          __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('setCurrentCity', to.query.city_name);
        }
      } else {
        if (__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.is_wx && !init_wx) {
          init_wx = true;
          init_wx_status = true;
          var _wx_config = __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('wxConfigFun', url);
          _wx_config.then(function (data) {
            if (data) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__assets_js_wx_config_js__["a" /* default */])(data, function () {
                var reInitConfig = __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('wxConfigFun', '');
                reInitConfig.then(function (data) {
                  if (data) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__assets_js_wx_config_js__["a" /* default */])(data);
                  }
                });
              });
              var _r = __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('getWXLocation');
              _r.then(function (point) {
                if (point) {
                  __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('setParamCurrentPos', {
                    lng: point.lng,
                    lat: point.lat
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('getCurrentCity', true);
                }
              }, function () {
                __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('getCurrentCity', true);
              });
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('getCurrentCity', true);
        }
      }
    }
  }

  if (__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.is_wx && !init_wx_status) {
    if (to.meta && to.meta.need_init_wx || (to.name === 'index' || to.name === 'lineDetailToBuy' || to.name === 'lineDetail') && !__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.is_android) {
      url = window.location.href;
      var _wx_config_cache = '';
      if (from.fullPath === '/') {
        _wx_config_cache = __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('wxConfigFun', window.location.protocol + '//' + window.location.hostname + '/commuter/dist' + to.fullPath);
      } else {
        _wx_config_cache = __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('wxConfigFun', url.replace(from.fullPath, to.fullPath));
      }
      _wx_config_cache.then(function (data) {
        if (data) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__assets_js_wx_config_js__["a" /* default */])(data, function () {
            var reInitConfig = __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].dispatch('wxConfigFun', '');
            reInitConfig.then(function (data) {
              if (data) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__assets_js_wx_config_js__["a" /* default */])(data);
              }
            });
          });
        }
      });
    }
  }
  init_wx_status = false;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__assets_js_util_js__["d" /* postCnzzDataTrack */])(to.fullPath, from.fullPath);
  if (__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.is_wx && window.scrollTo && !__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */].getters.is_android) {
    window.scrollTo(0, 0);
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */], router);

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(507),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 206:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

module.exports = window.BMap;

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(506),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(510),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 212:
/***/ (function(module, exports) {

(function (win, lib) {
  var doc = win.document;
  var docEl = doc.documentElement;
  var metaEl = doc.querySelector("meta[name = 'viewport']");
  var flexibleEl = doc.querySelector("meta[name = 'flexible']");
  var dpr = 0;
  var scale = 0;
  var tid;
  var flexible = lib.flexible || (lib.flexible = {});
  if (metaEl) {
    console.warn('将根据已有的meta标签来设置缩放比例');
    var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
    if (match) {
      scale = parseFloat(match[1]);
      dpr = parseInt(1 / scale);
    }
  } else if (flexibleEl) {
    var content = flexibleEl.getAttribute('content');
    if (content) {
      var initialDpr = content.match(/initial\-dpr = ([\d\.]+)/);
      var maximumDpr = content.match(/maximum\-dpr = ([\d\.]+)/);
      if (initialDpr) {
        dpr = parseFloat(initialDpr[1]);
        scale = parseFloat((1 / dpr).toFixed(2));
      }
      if (maximumDpr) {
        dpr = parseFloat(maximumDpr[1]);
        scale = parseFloat((1 / dpr).toFixed(2));
      }
    }
  }
  if (!dpr && !scale) {
    var isIPhone = win.navigator.appVersion.match(/iphone/gi);
    var devicePixelRatio = win.devicePixelRatio;
    if (isIPhone) {
      if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
        dpr = 3;
      } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
        dpr = 2;
      } else {
        dpr = 1;
      }
    } else {
      dpr = 1;
    }
    scale = 1 / dpr;
  }

  if (!metaEl) {
    metaEl = doc.createElement('meta');
    metaEl.setAttribute('name', 'viewport');
    metaEl.setAttribute('content', 'initial - scale=' + scale + ', maximum - scale=' + scale + ', minimum - scale=' + scale + ', user - scalable=no');
    if (docEl.firstElementChild) {
      docEl.firstElementChild.appendChild(metaEl);
    } else {
      var wrap = doc.createElement('div');
      wrap.appendChild(metaEl);
      doc.write(wrap.innerHTML);
    }
  }
  function refreshRem() {
    var width = docEl.getBoundingClientRect().width;
    if (width / dpr > 540) {
      width = 540 * dpr;
    }
    var rem = width / 10;
    docEl.style.fontSize = rem + 'px';
    flexible.rem = win.rem = rem;
  }
  win.addEventListener('resize', function () {
    clearTimeout(tid);
    tid = setTimeout(refreshRem, 300);
  }, false);
  win.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      clearTimeout(tid);
      tid = setTimeout(refreshRem, 300);
    }
  }, false);
  if (doc.readyState === 'complete') {
    doc.body.style.fontSize = 12 * dpr + 'px';
  } else {
    doc.addEventListener('DOMContentLoaded', function (e) {
      doc.body.style.fontSize = 12 * dpr + 'px';
    }, false);
  }
  refreshRem();
  flexible.dpr = win.dpr = dpr;
  flexible.refreshRem = refreshRem;
  flexible.rem2px = function (d) {
    var val = parseFloat(d) * this.rem;
    if (typeof d === 'string' && d.match(/rem$/)) {
      val += 'px';
    }
    return val;
  };
  flexible.px2rem = function (d) {
    var val = parseFloat(d) / this.rem;
    if (typeof d === 'string' && d.match(/px$/)) {
      val += 'rem';
    }
    return val;
  };
})(window, window['lib'] || (window['lib'] = {}));

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (data, callback) {
    wx.config({
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "getLocation"] });

    wx.error(function (res) {
        if (callback && typeof callback === 'function') {
            callback();
            callback = '';
        }
    });
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_reset_css__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_css__);










__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_mint_ui___default.a);

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('dateTime', function (date) {
  var _date = new Date(date);
  var _now_date = new Date();
  var _str;
  if (_now_date.getFullYear() + _now_date.getMonth() + _now_date.getDate() === _date.getFullYear() + _date.getMonth() + _date.getDate()) {
    _str = _date.getHours() + ':' + _date.getMinutes();
  } else {
    _str = _date.getFullYear() + '年' + _date.getMonth() + 1 + '月' + _date.getDate() + '日 ' + _date.getHours() + ':' + _date.getMinutes();
  }
  return _str;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('trim', function (value) {
  return value.trim();
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('money', function (price) {
  var _str_price = price + '';
  var _arr = _str_price.split('.');
  if (_arr.length === 1) {
    _str_price += '.00';
  } else {
    if (_arr[1].length === 1) {
      _str_price += '0';
    }
  }
  return _str_price;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('minTime', function (second) {
  second = Number(second);
  var _min = parseInt(second / 60);
  var _s = second - _min * 60;
  if (String(_min).length === 1) {
    _min = '0' + String(_min);
  }
  if (String(_s).length === 1) {
    _s = '0' + String(_s);
  }
  return _min + ':' + _s;
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is_wx", function() { return is_wx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is_android", function() { return is_android; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is_mobile", function() { return is_mobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "new_message", function() { return new_message; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "need_jump_login", function() { return need_jump_login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "innerHeight", function() { return innerHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading_text", function() { return loading_text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "back_path", function() { return back_path; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user_info", function() { return user_info; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "show_select_dialog", function() { return show_select_dialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sever_phone", function() { return sever_phone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enterprise_id", function() { return enterprise_id; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is_login", function() { return is_login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user_phone", function() { return user_phone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user_base_info", function() { return user_base_info; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is_trigger_collect", function() { return is_trigger_collect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is_trigger_search", function() { return is_trigger_search; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "common_cache_val", function() { return common_cache_val; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "check_search_line", function() { return check_search_line; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "history_address_list", function() { return history_address_list; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "home_address", function() { return home_address; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "company_place", function() { return company_place; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "search_location", function() { return search_location; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "current_pos_address", function() { return current_pos_address; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hot_city_list", function() { return hot_city_list; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "open_city_list", function() { return open_city_list; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "location_city", function() { return location_city; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "current_city", function() { return current_city; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "current_pos", function() { return current_pos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cache_entry_href", function() { return cache_entry_href; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is_loaded_location", function() { return is_loaded_location; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "organize_line_start_place", function() { return organize_line_start_place; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "organize_line_end_place", function() { return organize_line_end_place; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link_param_cache", function() { return link_param_cache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link_param_cache_time", function() { return link_param_cache_time; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "home_page_nav", function() { return home_page_nav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "commuter_sub_nav", function() { return commuter_sub_nav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "current_nav_id", function() { return current_nav_id; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "current_nav_index", function() { return current_nav_index; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "server_phone", function() { return server_phone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qusetion_category", function() { return qusetion_category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cache_check_address", function() { return cache_check_address; });

var is_wx = function is_wx(state) {
  return state.common.is_wx;
};
var is_android = function is_android(state) {
  return state.common.is_android;
};
var is_mobile = function is_mobile(state) {
  return state.common.is_mobile;
};
var new_message = function new_message(state) {
  return state.common.new_message;
};
var need_jump_login = function need_jump_login(state) {
  return state.common.need_jump_login;
};

var innerHeight = function innerHeight(state) {
  return state.common.win_height || window.innerHeight;
};

var loading_text = function loading_text(state) {
  return '正在加载中～';
};

var back_path = function back_path(state) {
  return state.common.back_path || '';
};

var user_info = function user_info(state) {
  return {
    id: state.userInfo.user_id,
    avatar: state.userInfo.user_avatar,
    nickname: state.userInfo.user_nickname,
    phone: state.userInfo.user_phone,
    token: state.userInfo.token
  };
};

var show_select_dialog = function show_select_dialog(state) {
  var _show = false;
  if (state.address.show_location_tips) {
    var _c_city = state.address.current_city || state.address.location_city;
    if (!_c_city) {
      _show = 1;
    } else {
      if (_c_city.indexOf('市') !== -1) {
        _c_city = _c_city.slice(0, -1);
      }
      if (state.address.open_city_name_list.indexOf(_c_city) === -1) {
        _show = 2;
      }
    }
  }
  return _show;
};

var sever_phone = function sever_phone(state) {
  var _phone = '';
  var _c_city = state.address.current_city || state.address.location_city || '';
  if (_c_city !== null && _c_city.indexOf('市') !== -1) {
    _c_city = _c_city.slice(0, -1);
  }
  if (state.address.open_city_name_object) {
    _phone = state.address.open_city_name_object[_c_city] && state.address.open_city_name_object[_c_city].phone;
  }
  return _phone;
};

var enterprise_id = function enterprise_id(state) {
  return (state.config.enterprise_id ? state.config.enterprise_id + '' : '') || '43';
};

var is_login = function is_login(state) {
  return state.userInfo.user_phone || state.userInfo.user_id;
};

var user_phone = function user_phone(state) {
  return state.userInfo.user_phone || state.userInfo.user_id;
};

var user_base_info = function user_base_info(state) {
  return state.userInfo.user_base_info;
};

var is_trigger_collect = function is_trigger_collect(state) {
  return state.common.is_trigger_collect;
};

var is_trigger_search = function is_trigger_search(state) {
  return state.common.is_trigger_search;
};

var common_cache_val = function common_cache_val(state) {
  return state.common.common_cache_val;
};

var check_search_line = function check_search_line(state) {
  return state.common.check_search_line;
};

var history_address_list = function history_address_list(state) {
  return state.address.history_address;
};

var home_address = function home_address(state) {
  var _place = state.address.location.home.address_title;
  if (!_place) {
    _place = state.userInfo.user_base_info.home_place;
  }
  return _place;
};

var company_place = function company_place(state) {
  var _place = state.address.location.company.address_title;
  if (!_place) {
    _place = state.userInfo.user_base_info.company_place;
  }
  return _place;
};

var search_location = function search_location(state) {
  return state.address.location;
};

var current_pos_address = function current_pos_address(state) {
  return state.address.current_pos_address;
};

var hot_city_list = function hot_city_list(state) {
  return state.address.hot_city_list;
};

var open_city_list = function open_city_list(state) {
  return state.address.open_city_list;
};

var location_city = function location_city(state) {
  return state.address.location_city;
};

var current_city = function current_city(state) {
  return state.address.current_city || state.address.location_city;
};

var current_pos = function current_pos(state) {
  return state.address.current_pos;
};

var cache_entry_href = function cache_entry_href(state) {
  return state.address.cache_entry_href;
};

var is_loaded_location = function is_loaded_location(state) {
  return state.address.is_loaded_location;
};

var organize_line_start_place = function organize_line_start_place(state) {
  return state.address.location.organize_start.address_title;
};

var organize_line_end_place = function organize_line_end_place(state) {
  return state.address.location.organize_end.address_title;
};

var link_param_cache = function link_param_cache(state) {
  return state.address.link_param_cache;
};

var link_param_cache_time = function link_param_cache_time(state) {
  return state.address.link_param_cache_time;
};

var home_page_nav = function home_page_nav(state) {
  return state.config.home_page_nav;
};

var commuter_sub_nav = function commuter_sub_nav(state) {
  return state.config.commuter_sub_nav;
};

var current_nav_id = function current_nav_id(state) {
  return state.config.home_page_nav_id;
};

var current_nav_index = function current_nav_index(state) {
  return state.config.home_page_nav_index;
};

var server_phone = function server_phone(state) {
  return state.common.server_phone;
};

var qusetion_category = function qusetion_category(state) {
  return state.questions.questions;
};

var cache_check_address = function cache_check_address(state) {
  return state.address.cache_check_address || '';
};

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(58);


var _mutations;





var baseUrl = 'https://wx.dudubashi.com';

var state = {
  common_cache_val: {},
  is_trigger_collect: false,
  is_trigger_search: false,
  back_path: '',
  is_loading: false,
  direction: 'forward',
  page_from: '',
  win_height: window.innerHeight,
  need_jump_login: false,
  server_phone: '4008-520-084',
  is_wx: /micromessenger/.test(navigator.userAgent.toLowerCase()),
  is_android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
  is_mobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.userAgent.indexOf('Adr') > -1,
  new_message: false,
  check_search_line: {} };

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["y" /* UPDATE_COMMON_CACHE_VAL */], function (state, param) {
  if (param.name) {
    state.common_cache_val[param.name] = param.val || '';
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["z" /* UPDATE_LOADING */], function (state, is_loading) {
  state.is_loading = is_loading;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["A" /* UPDATE_CHECK_LINE */], function (state, param) {
  state.check_search_line = param || {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["B" /* UPDATE_IS_TRIGGER_COLLECT */], function (state, val) {
  state.is_trigger_collect = val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["C" /* UPDATE_IS_TRIGGER_SEARCH */], function (state, val) {
  state.is_trigger_search = val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["D" /* UPDATE_WIN_HEIGHT */], function (state, val) {
  state.win_height = val || window.innerHeight;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["E" /* UPDATE_DIRECTION */], function (state, direction) {
  state.direction = direction;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["F" /* UPDATE_BACK_PATH */], function (state, back_path) {
  state.back_path = back_path;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["G" /* UPDATE_PAGE_FROM */], function (state, path) {
  state.page_from = path;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["H" /* UPDATE_NEW_MESSAGE */], function (state, val) {
  state.new_message = val;
}), _mutations);

var actions = {
  setLoading: function setLoading(_ref, val) {
    var commit = _ref.commit;

    commit('UPDATE_LOADING', val);
  },
  setCommonCacheVal: function setCommonCacheVal(_ref2, param) {
    var commit = _ref2.commit;

    commit('UPDATE_COMMON_CACHE_VAL', param);
  },
  setSearchCacheLine: function setSearchCacheLine(_ref3, param) {
    var commit = _ref3.commit;

    commit('UPDATE_CHECK_LINE', param);
  },
  setWinHeight: function setWinHeight(_ref4, val) {
    var commit = _ref4.commit;

    commit('UPDATE_WIN_HEIGHT', val);
  },
  setCollectStatus: function setCollectStatus(_ref5, val) {
    var commit = _ref5.commit;

    commit('UPDATE_IS_TRIGGER_COLLECT', val);
  },
  setSearchStatus: function setSearchStatus(_ref6, val) {
    var commit = _ref6.commit;

    commit('UPDATE_IS_TRIGGER_SEARCH', val);
  },
  getMessage: function getMessage(_ref7) {
    var commit = _ref7.commit,
        state = _ref7.state,
        rootState = _ref7.rootState;

    if (rootState.userInfo.user_id) {
      var params = {
        user_id: rootState.userInfo.user_id
      };
      if (rootState.config.enterprise_id) {
        params.enterprise_id = rootState.config.enterprise_id;
      }
      __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/users/message/message_notice').send(params).type('form').end(function (err, res) {
        if (err) {
          throw err;
        } else {
          res = JSON.parse(res.text);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["RequestCommonResponse"])({
            'rootState': rootState,
            'res': res,
            successCallback: function successCallback(res) {
              if (res.data.new_message !== 0) {
                commit('UPDATE_NEW_MESSAGE', true);
              } else {
                commit('UPDATE_NEW_MESSAGE', false);
              }
            },
            failCallback: function failCallback(res) {}
          });
        }
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: actions,
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(66);




var baseUrl = 'https://wx.dudubashi.com';

var state = {};

var mutations = {};

var actions = {
  getLineDetail: function getLineDetail(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state,
        rootState = _ref.rootState;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(baseUrl + '/index.php/line/info/get_line_info').send(params).type('form').end(function (err, res) {
        if (err) {
          throw err;
        } else {
          res = JSON.parse(res.text);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["RequestCommonResponse"])({
            'rootState': rootState,
            'res': res,
            successCallback: function successCallback(res) {
              resolve(res);
            },
            failCallback: function failCallback(res) {
              reject(res);
            }
          });
        }
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: actions,
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(58);


var _question = [{
  'suggest_id': '9',
  'title': '购票问题',
  'question_list': [{
    'title': 'Q1: 去哪里买票？',
    'content': ['1.下载嘟嘟巴士APP或关注嘟嘟巴士微信公众号使用购票']
  }, {
    'title': 'Q2: 没有我的线路怎么办？',
    'content': ['1.下载嘟嘟巴士后如果发现没有线路，可以使用<span class="custom_make">【定制开通】</span>功能', '2.嘟嘟巴士每周都会有新增线路，请关注我们的微信公众号或下载嘟嘟巴士']
  }, {
    'title': 'Q3: 单次票和乘车卡的区别是什么？',
    'content': ['1.单次票：适用于临时或不规律乘车，可单次购买', '2.乘车卡：车卡可在一定时间范围内多次乘车使用']
  }, {
    'title': 'Q4: 买票后不坐车能退票吗？',
    'content': ['1.在始发站发车前可退票，请前往<span class="travel_order">【出行订单】</span>-订单详情-退票”进行退票，如果仍有疑问可致电<a class="custom_server" href="tel:4008-520-084">【客服】</a>操作退票事宜']
  }]
}, {
  'suggest_id': '10',
  'title': '乘车问题',
  'question_list': [{
    'title': 'Q1: 买票后去哪里乘车？',
    'content': ['1.在APP中买票后点击班次详情的具体站点，弹出实景地图照片显示上车点，第一次坐车的小伙伴买票后务必加入微信群或联系线路负责人，确认好上车地点，以免错过班车']
  }, {
    'title': 'Q2: 如何知道现在车在哪儿？',
    'content': ['1.嘟嘟巴士每台巴士车上都有导航系统，在APP班次详情中点击车辆位置可以实时定位车辆位置']
  }, {
    'title': 'Q3: 如果错过了上车时间，巴士车会等我吗？',
    'content': ['1.工作生活中难免会遇到迟到上车的情况，这种时候只要在微信群里提前告知队长，巴士车都会酌情等候2分钟。为了大多数乘客的乘车体验，嘟嘟巴士建议您准时到达上车点候车']
  }, {
    'title': 'Q4: 嘟嘟巴士除了上下班接送外还有别的巴士服务吗？',
    'content': ['1.除了上下班接送班车外，嘟嘟巴士还提供专业的巴士包车、城际直通车、周边游定制巴士服务，这些功能服务都能在嘟嘟巴士中找到']
  }]
}, {
  'suggest_id': '11',
  'title': '安全保障问题',
  'question_list': [{
    'title': 'Q1: 乘坐嘟嘟巴士安全吗，巴士司机靠谱吗？',
    'content': ['1.嘟嘟巴士严格筛选巴士与司机，务必保证每辆巴士车都是经验丰富的老师傅驾驶，车辆安全，证件齐全，并且为每个乘客提供100万元保额的座位险']
  }, {
    'title': 'Q2: 嘟嘟巴士的行驶路线是怎么定的？',
    'content': ['1.APP中可查看巴士车行驶路线和停靠站点，嘟嘟巴士拒绝沿路揽客，一人一座专车直达目的地，避开交通拥堵和不必要的绕路']
  }, {
    'title': 'Q3: 如何知道现在车在哪儿？',
    'content': ['1.嘟嘟巴士每台巴士车上都有导航系统，在APP班次详情中点击车辆位置可以实时定位车辆位置，可以实时给家人朋友分享自己所在位置']
  }, {
    'title': 'Q4: 巴士准时吗？乘车的时候会不会坐过站？',
    'content': ['1.嘟嘟巴士的每趟班车都会按时定点在乘车点停靠，不用担心坐过站，每条线路上都有车队队长负责报站名提醒上下车']
  }]
}, {
  'suggest_id': '12',
  'title': '优惠券问题',
  'question_list': [{
    'title': 'Q1: 怎么得到更多乘车优惠券？',
    'sign': ['优惠码'],
    'content': ['1.邀请好友可得10元乘车优惠券，多邀多得，不设上限。嘟嘟巴士官方也会做活动，积极参加官方活动，输入<span class="coupon">【优惠码】</span>即可兑换']
  }, {
    'title': 'Q2: 邀请好友能得多少优惠券？',
    'content': ['1.邀请好友后，被邀请者7天内注册成功并购票，邀请者将得到10元优惠券，多邀多得，不设上限']
  }, {
    'title': 'Q3: 优惠券为什么不能使用？',
    'content': ['1.请核对使用时间：优惠券上注明的起止日期为购票付款使用日期', '2.请核对金额：查看付款金额是否满足“满就减”、“上下班券”的条件', '3.请核对票务：对应的优惠券只能购买对应的车票']
  }]
}, {
  'suggest_id': '13',
  'title': '其他问题',
  'question_list': [{
    'title': 'Q1: 第一次乘车需要帮助？',
    'content': ['1.第一次乘车如需帮助请直接联系线路负责人或添加客服微信，客服将第一时间为您处理问题']
  }, {
    'title': 'Q2: 购票成功后会有什么提示？',
    'content': ['1.购票成功后5分钟内会收到短信通知']
  }, {
    'title': 'Q3: 嘟嘟巴士何时开通更多线路，进驻更多城市？',
    'content': ['1.嘟嘟巴士每周都会新增更多线路，请关注微信公众号查看每周详细新增路线']
  }]
}];

var state = {
  questions: _question
};

var mutations = {};
var actions = {};
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: actions,
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_util_js__ = __webpack_require__(56);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  store: __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */],
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['need_jump_login', 'is_login', 'enterprise_id']), {
    title: function title() {
      return this.$route.meta ? this.$route.meta.title : '';
    },
    keep_alive: function keep_alive() {
      return this.$route.meta ? this.$route.meta.keep_alive : '';
    },
    is_loading: function is_loading() {
      return this.$store.state.common.is_loading;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['getOpenCity', 'setWinHeight', 'postAnalyzeData']), {
    resize: function resize() {
      var _self = this;
      if (window) {
        window.onresize = function () {
          _self.setWinHeight(window.innerHeight);
        };
      }
    }
  }),
  watch: {
    need_jump_login: function need_jump_login(val) {
      if (val) {
        var _self = this;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util_js__["a" /* showTips */])(_self.is_login ? '登录失效，请重新登录' : '请先登录');
        var path = '/login?from=' + encodeURIComponent(_self.$route.fullPath);
        if (_self.enterprise_id) {
          path = '/e/' + _self.enterprise_id + path;
        }
        _self.$router.push({
          path: path
        });
      }
    },
    '$route': function $route() {
      var _self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util_js__["b" /* postCnzzData */])('9.0 页面访问', _self.title || '统计');
      if (_self.enterprise_id) {
        _self.postAnalyzeData({
          category: '页面访问',
          action: _self.enterprise_id || 'id',
          opt_label: _self.title || '首页'
        });
      }
    }
  },
  created: function created() {
    var _self = this;
    if (_self.enterprise_id) {
      _self.getOpenCity();
      _self.postAnalyzeData({
        category: '企业访问',
        action: _self.enterprise_id || 'id'
      });
    }
    _self.resize();
  },
  updated: function updated() {}
});

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirm',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    user_real_phone: 'user_phone'
  })),
  props: {
    is_show: {
      type: Boolean,
      default: true
    },
    leftContent: String,
    rightContent: String,
    title: String,
    subTitle: String,
    colorType: {
      type: String,
      default: 'left'
    },
    is_logout: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    },
    confirm: function confirm() {
      this.$emit('confirm');
    }
  }
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notice',
  props: {
    position: {},
    line_id: {}
  },
  data: function data() {
    return {
      show: false,
      notice: '',
      notice_id: null
    };
  },

  watch: {
    current_city: function current_city() {
      this.init();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['enterprise_id', 'current_city'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['getNotice']), {
    closeNotice: function closeNotice() {
      this.show = false;

      this.$emit('noticed', false);
    },
    jumpNotice: function jumpNotice() {
      var path = '/notice/' + this.notice_id;
      if (this.enterprise_id) {
        path = '/e/' + this.enterprise_id + path;
      }
      this.$router.push(path);
    },
    init: function init() {
      var _self = this;
      var _params = {
        position: _self.position,
        city: '深圳市'
      };
      if (_self.position !== 1) {
        _params.line_id = _self.line_id;
      }
      _self.getNotice(_params).then(function (res) {
        if (res.data.title) {
          _self.show = true;
          _self.notice = res.data.title;
          _self.notice_id = res.data.id;

          _self.$emit('noticed', true);
        }
      });
    }
  }),
  created: function created() {
    var _self = this;
    _self.init();
  }
});

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    show: {
      type: Boolean,
      default: false
    },
    pos: {
      type: String,
      default: 'left'
    },
    tran: {
      type: String,
      default: 'overlay'
    }
  },
  data: function data() {
    return {
      drawerWidth: 0,
      translateX: 0
    };
  },

  watch: {
    show: function show() {
      if (!this.show) {
        this.$emit('on-hide');
      } else {
        this.$emit('on-show');
      }

      if (this.tran === 'overlay') {
        return;
      }
      if (!this.show) {
        this.translateX = 0;
      } else {
        this.translateX = this.pos === 'left' ? this.drawerWidth : -this.drawerWidth;
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.drawerWidth = this.$refs.drawer.clientWidth || 300;
    });
  },

  methods: {
    hideMask: function hideMask() {
      if (this.show) {
        this.$emit('change-show', false);
      }
    }
  }
});

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_util__ = __webpack_require__(56);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommuteAddress',
  components: {
    mtLoadmore: __WEBPACK_IMPORTED_MODULE_1_mint_ui__["Loadmore"]
  },
  props: {
    show_notice: Boolean
  },
  data: function data() {
    return {
      search_list: [],
      search_page: 1,
      is_loading: false,
      all_search_loaded: false,
      page_limit: 20,
      is_fixed_bottom: true,
      list_scroll_top: 0 };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['search_location', 'enterprise_id', 'current_pos', 'current_city', 'is_mobile', 'innerHeight', 'is_login', 'is_trigger_collect', 'user_info']), {
    start_str: function start_str() {
      var self = this;
      var str = '';
      if (self.search_location.commute_start.is_current_pos) {
        str = '我的位置';
      } else {
        str = self.search_location.commute_start.address_title || '';
      }
      return str;
    },
    end_str: function end_str() {
      var self = this;
      var str = '';
      if (self.search_location.commute_end.is_current_pos) {
        str = '我的位置';
      } else {
        str = self.search_location.commute_end.address_title || '';
      }
      return str;
    },
    list_height: function list_height() {
      var self = this;
      var val = 0;
      if (self.innerHeight) {
        val = self.innerHeight - 281 - 10;
        if (self.show_notice) {
          val = val - 30;
        }
        if (!self.is_login) {
          val = val + 27;
        }
      }
      return val;
    },
    is_show_logo: function is_show_logo() {
      var self = this;
      var status = true;
      if (self.is_loading) {
        status = false;
      } else {
        if (self.search_list.length > 0 && !self.all_search_loaded) {
          status = false;
        }
      }
      return status;
    }
  }),
  watch: {
    'is_login': function is_login(val) {
      var _self = this;

      if (val) {
        _self.searchList(1);
      } else {
        _self.all_search_loaded = true;

        _self.search_list = [];
        _self.$nextTick(function () {
          _self.checkScroll();
        });
      }
    }
  },
  created: function created() {
    var _self = this;

    if (_self.is_login) {
      _self.searchList(1);
    }
  },
  activated: function activated() {
    var _self = this;
    if (_self.is_login && _self.is_trigger_collect) {
      _self.searchList(1);
    } else {
      _self.$nextTick(function () {
        _self.scrollTop(_self.list_scroll_top);
      });
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['exchangeLocation', 'setLoading', 'searchCollectLines', 'setCollectStatus', 'setSearchStatus']), {
    loadBottom: function loadBottom(type) {
      var self = this;
      if (!self.is_mobile && !type) {
        return false;
      }

      if (!self.all_search_loaded && !self.is_loading) {
        self.searchList(self.search_page + 1);
      }
    },
    switchSearchType: function switchSearchType() {
      var _self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["b" /* postCnzzData */])('1.2 点击编号搜索tab');

      _self.$router.replace({
        path: '/e/' + _self.enterprise_id + '/',
        query: {
          type: 'code'
        }
      });
    },
    jumpSearchPage: function jumpSearchPage(from_type) {
      var _self = this;
      var _category_id;
      switch (from_type) {
        case 'commute_start':
          _category_id = '1.1.1 输入起点地址';
          break;
        case 'commute_end':
          _category_id = '1.1.2 输入终点地址';
          break;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["b" /* postCnzzData */])(_category_id);
      var path = '/e/' + _self.enterprise_id + '/checkAddress/' + from_type;
      if (from_type === 'commute_end') {
        path = '/e/' + _self.enterprise_id + '/checkAddress/' + from_type;
      }
      _self.$router.push({
        path: path
      });
    },
    linkDetail: function linkDetail(line) {
      var _self = this;
      var path = '/lineDetail/' + line.line_id;
      if (line.sales_type + '' === '1') {
        path = '/lineDetailToBuy/' + line.line_id;
      }
      var _id = '';
      if (_self.user_info && _self.user_info.id) {
        _id = _self.user_info.id + '';
      } else {
        _id = '未登录';
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["b" /* postCnzzData */])('12.1.1 首页收藏页面new', _id, line.line_id + '');
      _self.$router.push({
        path: '/e/' + _self.enterprise_id + path,
        query: {
          is_search: '1',
          is_collect: '1'
        }
      });
    },
    clickSearch: function clickSearch() {
      reportEvent('华为首页线路查询');

      var self = this;
      self.jumpSearchResult();
    },
    searchList: function searchList(page) {
      var _self = this;
      var _page = page || 1;
      _self.is_loading = true;
      _self.setCollectStatus(false);
      if (_page === 1) {
        _self.setLoading(true);
      }

      _self.searchCollectLines({
        page: _page,
        page_size: 15
      }).then(function (res) {
        if (res.data.total_page <= res.data.page) {
          _self.all_search_loaded = true;
        } else {
          _self.all_search_loaded = false;
        }
        _self.search_page = _page;
        if (_page === 1) {
          _self.search_list = [];
        }
        _self.search_list = _self.search_list.concat(res.data.list || []);
        _self.$nextTick(function () {
          _self.setLoading(false);
          _self.is_loading = false;
          _self.checkScroll();
          setTimeout(function () {
            if (_self.$refs.loadmore && _self.search_page > 1) {
              _self.$refs.loadmore.onBottomLoaded();
            }
          }, 500);
        });
      }, function (res) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["a" /* showTips */])(res.info || '请求数据失败！');
        _self.setLoading(false);
        _self.is_loading = false;
        setTimeout(function () {
          if (_self.$refs.loadmore && _self.search_page > 1) {
            _self.$refs.loadmore.onBottomLoaded();
          }
        }, 500);
      });
    },
    listScroll: function listScroll() {
      var _self = this;
      var $List = '';
      var _scrollTop = 0;
      var _clientHeight = 0;
      var _scrollHeight = 0;
      if (_self.$refs.commute_list) {
        $List = _self.$refs.commute_list;
        _scrollTop = $List.scrollTop || 0;
        _clientHeight = $List.clientHeight || 0;
        _scrollHeight = $List.scrollHeight || 0;
        _self.list_scroll_top = _scrollTop;
      }

      if (!_self.is_mobile && _scrollHeight > 0) {
        if (_scrollHeight - _clientHeight - _scrollTop < 10) {
          if (!_self.all_search_loaded) {
            _self.loadBottom('trigger');
          }
        }
      }
    },
    checkScroll: function checkScroll() {
      var _self = this;
      var $List = '';
      var _clientHeight = 0;
      var _scrollHeight = 0;
      if (_self.$refs.commute_list) {
        $List = _self.$refs.commute_list;
        _clientHeight = $List.clientHeight || 0;
        _scrollHeight = $List.scrollHeight || 0;
      }
      if (_scrollHeight > _clientHeight) {
        _self.is_fixed_bottom = false;
      } else {
        _self.is_fixed_bottom = true;
      }
    },
    scrollTop: function scrollTop(number) {
      var _self = this;
      var $List = '';
      if (_self.$refs.commute_list) {
        $List = _self.$refs.commute_list;
        if (number && $List.scrollHeight && $List.scrollHeight > 0) {
          $List.scrollTop = number || 0;
        } else {
          if ($List.scrollTop > 0) {
            $List.scrollTop = 0;
          }
        }
      }
    },
    jumpSearchResult: function jumpSearchResult() {
      var _self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["b" /* postCnzzData */])('1.1.3 点击上下班地址搜索按钮');
      if (_self.start_str && _self.end_str) {
        _self.setSearchStatus(true);
        _self.$router.push({
          path: '/e/' + _self.enterprise_id + '/searchResultOpt',
          query: {
            city_name_search: _self.current_city || '',
            from_address: _self.search_location.commute_start.address_title || '',
            to_address: _self.search_location.commute_end.address_title || '',
            startlocation: _self.search_location.commute_start.associate_location || '',
            startlocation_type: _self.search_location.commute_start.is_current_pos ? 'baidu' : '',
            endlocation: _self.search_location.commute_end.associate_location || '',
            endlocation_type: _self.search_location.commute_end.is_current_pos ? 'baidu' : ''
          }
        });
      } else {
        if (!_self.search_location.commute_start || !_self.search_location.commute_start.address_title) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["a" /* showTips */])('请输入出发地址');
        } else if (!_self.search_location.commute_end || !_self.search_location.commute_end.address_title) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["a" /* showTips */])('请输入终点地址');
        }
      }
    },
    exchangeAddress: function exchangeAddress() {
      this.exchangeLocation();
    }
  })
});

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_util__ = __webpack_require__(56);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CommuteCode',
  components: {
    mtLoadmore: __WEBPACK_IMPORTED_MODULE_1_mint_ui__["Loadmore"]
  },
  data: function data() {
    return {
      search_text: '',
      search_list: [],
      search_page: 1,
      search_date: '',
      is_fixed_bottom: true,
      is_focus: false,
      is_loading: false,
      all_search_loaded: false,
      list_scroll_top: 0 };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['enterprise_id', 'is_mobile', 'user_info', 'innerHeight']), {
    list_height: function list_height() {
      var self = this;
      var val = 0;
      if (self.innerHeight) {
        val = self.innerHeight - 204 - 10;
      }
      return val;
    },
    is_show_logo: function is_show_logo() {
      var self = this;
      var status = true;
      if (self.is_focus || self.is_loading) {
        status = false;
      } else {
        if (self.search_list.length > 0 && !self.all_search_loaded) {
          status = false;
        }
      }
      return status;
    }
  }),
  created: function created() {
    var _self = this;
    _self.setLoading(false);
    _self.search_date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["i" /* formatDay */])('', 'line');
  },
  activated: function activated() {
    var _self = this;
    _self.$nextTick(function () {
      _self.scrollTop(_self.list_scroll_top);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['setLoading', 'searchLineCode']), {
    inputEve: function inputEve(type) {
      var self = this;
      if (type === 'focus') {
        self.is_focus = true;
      } else if (type === 'blur') {
        self.is_focus = false;
      }
    },
    loadBottom: function loadBottom(type) {
      var self = this;
      if (!self.is_mobile && !type) {
        return false;
      }

      if (!self.all_search_loaded && !self.is_loading) {
        self.searchList(self.search_page + 1);
      }
    },
    clearText: function clearText() {
      var _self = this;
      _self.search_text = '';
    },
    switchSearchType: function switchSearchType() {
      var _self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["b" /* postCnzzData */])('1.2 点击地址搜索tab');

      _self.$router.replace({
        path: '/e/' + _self.enterprise_id + '/',
        query: {
          type: 'address'
        }
      });
    },
    linkDetail: function linkDetail(line) {
      var _self = this;
      var path = '/lineDetail/' + line.line_id;
      if (line.sales_type + '' === '1') {
        path = '/lineDetailToBuy/' + line.line_id;
      }
      _self.$router.push({
        path: '/e/' + _self.enterprise_id + path + '?is_search=1&unique_key=' + (line.unique_key || '')
      });
    },
    clickSearch: function clickSearch() {
      reportEvent('华为首页编号查询');

      var self = this;
      self.scrollTop();
      self.searchList(1);
    },
    searchList: function searchList(page) {
      var _self = this;
      var _page = page || 1;
      var _id = '';
      if (_self.search_text) {
        _self.is_loading = true;

        if (_page === 1) {
          _self.setLoading(true);
        }
        _self.searchLineCode({
          line_code: _self.search_text || '',
          page: _page,
          page_size: 15,
          date: _self.search_date || '' }).then(function (res) {
          if (res.data.total_page <= res.data.page) {
            _self.all_search_loaded = true;
          } else {
            _self.all_search_loaded = false;
          }
          _self.search_page = _page;
          if (_page === 1) {
            _self.search_list = [];
          }
          _self.search_list = _self.search_list.concat(res.data.list || []);
          if (_page === 1) {
            if (_self.user_info && _self.user_info.id) {
              _id = _self.user_info.id + '';
            } else {
              _id = '未登录';
            }
            if (_self.search_list.length > 0) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["b" /* postCnzzData */])('13.1.1 首页编号搜索页面new', _id, '有数据');
            } else {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["b" /* postCnzzData */])('13.1.1 首页编号搜索页面new', _id, '无数据');
            }
          }
          _self.$nextTick(function () {
            _self.setLoading(false);
            _self.is_loading = false;
            _self.checkScroll();
            setTimeout(function () {
              if (_self.$refs.loadmore && _self.search_page > 1) {
                _self.$refs.loadmore.onBottomLoaded();
              }
            }, 500);
          });
        }, function (res) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["a" /* showTips */])(res.info || '请求数据失败！');
          _self.setLoading(false);
          _self.is_loading = false;
          setTimeout(function () {
            if (_self.$refs.loadmore) {
              _self.$refs.loadmore.onBottomLoaded();
            }
          }, 500);
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_util__["a" /* showTips */])('输入线路编号或名称！');
      }
    },
    listScroll: function listScroll() {
      var _self = this;
      var $List = '';
      var _scrollTop = 0;
      var _clientHeight = 0;
      var _scrollHeight = 0;
      if (_self.$refs.commute_list) {
        $List = _self.$refs.commute_list;
        _scrollTop = $List.scrollTop || 0;
        _clientHeight = $List.clientHeight || 0;
        _scrollHeight = $List.scrollHeight || 0;
        _self.list_scroll_top = _scrollTop;
      }

      if (!_self.is_mobile && _scrollHeight > 0) {
        if (_scrollHeight - _clientHeight - _scrollTop < 10) {
          if (!_self.all_search_loaded) {
            _self.loadBottom('trigger');
          }
        }
      }
    },
    checkScroll: function checkScroll() {
      var _self = this;
      var $List = '';
      var _clientHeight = 0;
      var _scrollHeight = 0;
      if (_self.$refs.commute_list) {
        $List = _self.$refs.commute_list;
        _clientHeight = $List.clientHeight || 0;
        _scrollHeight = $List.scrollHeight || 0;
      }
      if (_scrollHeight > _clientHeight) {
        _self.is_fixed_bottom = false;
      } else {
        _self.is_fixed_bottom = true;
      }
    },
    scrollTop: function scrollTop(number) {
      var _self = this;
      var $List = '';
      if (_self.$refs.commute_list) {
        $List = _self.$refs.commute_list;
        if (number && $List.scrollHeight && $List.scrollHeight > 0) {
          $List.scrollTop = number || 0;
        } else {
          if ($List.scrollTop > 0) {
            $List.scrollTop = 0;
          }
        }
      }
    }
  })
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'enterprice',
  props: {
    title: {},
    transition: {}
  },
  computed: {
    keep_alive: function keep_alive() {
      return this.$route.meta.keep_alive;
    }
  },
  methods: {},
  created: function created() {}
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SliderBar__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SliderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_SliderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Notice__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Confirm__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_CommuteAddress__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_CommuteAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_CommuteAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_CommuteCode__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_CommuteCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_CommuteCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_scss_sprites_icons_optimize_scss__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_scss_sprites_icons_optimize_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_scss_sprites_icons_optimize_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_scss_sprites_nav_icons_scss__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_scss_sprites_nav_icons_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_scss_sprites_nav_icons_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_util__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuex__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Index',
  components: {
    notice: __WEBPACK_IMPORTED_MODULE_2__components_Notice___default.a,
    slideBar: __WEBPACK_IMPORTED_MODULE_1__components_SliderBar___default.a,
    Confirm: __WEBPACK_IMPORTED_MODULE_3__components_Confirm___default.a,
    commuteAddress: __WEBPACK_IMPORTED_MODULE_4__pages_CommuteAddress___default.a,
    CommuteCode: __WEBPACK_IMPORTED_MODULE_5__pages_CommuteCode___default.a
  },
  data: function data() {
    return {
      view_type: 'address',
      show_logout_dialog: false,
      show_location_dialog: false,
      is_true: false,
      user_real_phone: null,
      pos: 'left',
      tran: 'overlay',
      drawerShow: false,
      show_last_feedback_message: false,
      last_feedback_message: '',
      last_feedback_title: '',
      last_feedback_id: '',
      last_feedback_message_id: '',
      cacheCity: window.localStorage.getItem('location_city_cache') || '',
      is_show_notice: false,
      message_timer: '' };
  },

  props: {
    title: {},
    transition: {}
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["mapGetters"])(['is_login', 'user_phone', 'enterprise_id', 'innerHeight', 'server_phone', 'new_message', 'current_city', 'show_select_dialog', 'sever_phone', 'is_loaded_location', 'user_info', 'current_pos']), {
    current_title: function current_title() {
      return this.$route.meta.title;
    },
    current_router: function current_router() {
      return this.$route.name;
    },

    location_dialog_type: {
      get: function get() {
        return this.show_select_dialog === 1 && this.show_location_dialog && this.cacheCity;
      },
      set: function set(val) {
        this.show_location_dialog = false;
      }
    }
  }),
  watch: {
    '$route': function $route(to, _from) {
      var _self = this;
      if (to.query.type && (to.query.type === 'code' || to.query.type === 'address')) {
        _self.view_type = to.query.type || 'address';
      }
      if (_from && _from.name === 'myMessage') {
        if (_self.is_login) {
          _self.getMessage();
        }
      }
    },
    is_login: function is_login(val) {
      if (val) {
        this.getMessage();
        this.getLastMessage();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["mapActions"])(['userLogout', 'setUserInfo', 'setCurrentCity', 'getMessage', 'setLoadedLocation', 'getLastFeedbackMessage']), {
    linkVersion: function linkVersion() {
      reportEvent('返回旧版');

      var _self = this;
      var _id = '';
      if (_self.user_info && _self.user_info.id) {
        _id = _self.user_info.id + '';
      } else {
        _id = '未登录';
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__assets_js_util__["b" /* postCnzzData */])('15.2.1 首页跳转旧版入口', _id, '点击');
      var url = '/commuter_old/dist/e/43/';
      if (_self.current_pos && _self.current_pos.lat) {
        url = url + '?lat=' + _self.current_pos.lat + '&lng=' + _self.current_pos.lng;
      }
      if (_self.current_pos && _self.current_pos.lat && _self.current_city) {
        url = url + '&city_name=' + _self.current_city;
      }
      window.location.href = url;
    },
    setCacheCity: function setCacheCity() {
      var city_name = this.cacheCity;
      this.location_dialog_type = false;
      this.setCurrentCity(city_name);
    },
    markClick: function markClick() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__assets_js_util__["b" /* postCnzzData */])('5.4 点击客服电话');
    },
    showNotice: function showNotice(val) {
      var self = this;
      self.is_show_notice = val || false;
    },
    jumpPage: function jumpPage(path) {
      if (path === '/selectCity') {
        reportEvent('切换城市');
      }
      if (path === '/collectLine') {
        reportEvent('首页我的收藏');
      }
      var query = {};

      if (path === '/feedback') {
        reportEvent('意见反馈');
        query = {
          from: 'index'
        };
      }
      if (path === '/feedbackEnt') {
        reportEvent('线路反馈');
        query = {
          from_type: 'home'
        };
      }
      if (this.enterprise_id) {
        path = '/e/' + this.enterprise_id + path;
      }
      this.$router.push({
        path: path,
        query: query
      });
    },
    login: function login() {
      reportEvent('跳转登录');
      var _self = this;
      if (!_self.is_login) {
        var path = '/login';
        if (_self.enterprise_id) {
          path = '/e/' + _self.enterprise_id + path;
        }
        _self.$router.push({
          path: path,
          query: {
            from: _self.$route.fullPath
          }
        });
      }
    },
    logout: function logout() {
      var _self = this;
      var _result = this.userLogout();
      _result.then(function (_res) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__assets_js_util__["a" /* showTips */])('登出成功');
        _self.show_logout_dialog = false;

        _self.setUserInfo({});
      }, function (_res) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__assets_js_util__["a" /* showTips */])('登出失败');
      });
      return false;
    },
    isLogout: function isLogout() {
      this.show_logout_dialog = true;
    },
    onHide: function onHide() {},
    changeDrawerShow: function changeDrawerShow(state) {
      this.drawerShow = state;
    },
    onShow: function onShow() {},
    getLastMessage: function getLastMessage() {
      var _self = this;
      if (_self.is_login) {
        _self.getLastFeedbackMessage().then(function (res) {
          var _text = '反馈回复：';
          if (res && res.data && res.data.reply_content) {
            if (res.data.rank === '0') {
              _text = '供应商客服回复：';
            } else if (res.data.rank === '1') {
              _text = '供应商项目经理回复：';
            } else if (res.data.rank === '1') {
              _text = '企业回复：';
            }
            _self.last_feedback_title = _text;
            _self.last_feedback_message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__assets_js_util__["m" /* cutstr */])(res.data.reply_content || '', 30);
            setTimeout(function () {
              _self.show_last_feedback_message = true;
            }, 600);
            _self.message_timer = setTimeout(function () {
              _self.message_timer = '';
              _self.show_last_feedback_message = false;
            }, 5000);
            _self.last_feedback_id = res.data.suggest_id || '';
            _self.last_feedback_message_id = res.data.id || '';
          }
        });
      }
    },
    toFeedbackDetail: function toFeedbackDetail() {
      var _self = this;
      _self.last_feedback_message = '';
      _self.$router.push({
        path: '/e/' + _self.enterprise_id + '/feedbackDetail/' + _self.last_feedback_message_id,
        query: {
          suggest_id: _self.last_feedback_id
        }
      });
    }
  }),
  created: function created() {
    var _self = this;
    if (_self.$route.query.type) {
      _self.view_type = _self.$route.query.type;
    }
    _self.show_location_dialog = true;

    if (!_self.is_loaded_location) {
      setTimeout(function () {
        _self.setLoadedLocation(true);
      }, 6000);
    }
    if (_self.is_login) {
      _self.getMessage();
      _self.getLastMessage();
    }

    setTimeout(function () {
      try {
        var _remove_list = [];
        for (var i = 0, len = document.body.children.length; i < len; i++) {
          var _ele = document.body.children[i];
          if (_ele) {
            if (!(_ele.tagName === 'DIV' && _ele.id === 'app')) {
              if (_ele.tagName !== 'SCRIPT') {
                _remove_list.push(_ele);
              }
            }
          }
        }
        for (var j = 0, j_len = _remove_list.length; j < j_len; j++) {
          if (_remove_list[j]) {
            _remove_list[j].parentNode.removeChild(_remove_list[j]);
          }
        }
      } catch (e) {
        console.log(e);
      }
    }, 2000);
  },
  beforeDestroy: function beforeDestroy() {
    var _self = this;
    if (_self.message_timer) {
      clearTimeout(_self.message_timer);
      _self.message_timer = '';
    }
  },
  mounted: function mounted() {
    reportEvent('华为首页');
  }
});

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/43_default_avatar.dac949c.png";

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.e7c8f03.gif";

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(511),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(508),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(509),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(504),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(505),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 504:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('keep-alive', [(_vm.keep_alive) ? _c('router-view', {
    attrs: {
      "title": _vm.title
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.keep_alive) ? _c('router-view', {
    attrs: {
      "title": _vm.title
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    staticClass: "page-view-index"
  }, [_c('div', [_c('slide-bar', {
    attrs: {
      "show": _vm.drawerShow,
      "pos": _vm.pos,
      "tran": _vm.tran
    },
    on: {
      "change-show": _vm.changeDrawerShow,
      "on-hide": _vm.onHide,
      "on-show": _vm.onShow
    }
  }, [_c('div', {
    staticClass: "userInfo",
    attrs: {
      "slot": "drawer"
    },
    slot: "drawer"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": __webpack_require__(496)
    },
    on: {
      "click": _vm.login
    }
  }), _vm._v(" "), (_vm.user_phone) ? _c('p', {
    staticClass: "user_phone"
  }, [_vm._v(_vm._s(_vm.user_phone))]) : _vm._e(), _vm._v(" "), (_vm.user_phone) ? _c('p', {
    staticClass: "logout",
    on: {
      "click": _vm.isLogout
    }
  }, [_c('span', [_vm._v("退出登录")])]) : _vm._e(), _vm._v(" "), (!_vm.user_phone) ? _c('p', {
    staticClass: "loginBtn",
    on: {
      "click": _vm.login
    }
  }, [_c('span', [_vm._v("点击登录")])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "mainNav"
    }
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.jumpPage('/myOrder')
      }
    }
  }, [_c('i', {
    staticClass: "icon_nav_order"
  }), _vm._v("我的订单\n          ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.jumpPage('/collectLine')
      }
    }
  }, [_c('i', {
    staticClass: "icon_nav_collect"
  }), _vm._v("我的收藏\n          ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.jumpPage('/feedbackEnt')
      }
    }
  }, [_c('i', {
    staticClass: "icon_nav_custom"
  }), _vm._v("线路反馈\n          ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.jumpPage('/myMessage')
      }
    }
  }, [_c('i', {
    staticClass: "icon_nav_message"
  }), _vm._v(" "), _c('span', {
    staticClass: "new_message_tips"
  }, [_vm._v("\n              我的消息\n              "), (_vm.new_message) ? _c('b') : _vm._e()])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.jumpPage('/feedback')
      }
    }
  }, [_c('i', {
    staticClass: "icon_nav_help"
  }), _vm._v("意见反馈\n          ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.jumpPage('/checkedRecord')
      }
    }
  }, [_c('i', {
    staticClass: "icon_nav_checked_record"
  }), _vm._v("验票记录\n          ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.linkVersion.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "icon_back_version"
  }), _vm._v("返回旧版\n          ")])]), _vm._v(" "), _c('footer', {
    staticClass: "slider_bottom",
    staticStyle: {
      "min-height": "50px"
    }
  }, [_c('div', {
    staticClass: "serive_phone"
  }, [(_vm.sever_phone) ? _c('span', [_vm._v("客服电话：")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.sever_phone
    },
    on: {
      "click": _vm.markClick
    }
  }, [_vm._v(_vm._s(_vm.sever_phone))])]), _vm._v(" "), _c('span', {
    staticClass: "select_city",
    on: {
      "click": function($event) {
        return _vm.jumpPage('/selectCity')
      }
    }
  }, [_c('i', {
    staticClass: "icon_location"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.current_city || '无定位'))])])])])])], 1), _vm._v(" "), ((_vm.show_select_dialog == 2 || (!_vm.cacheCity && _vm.show_select_dialog == 1) || !_vm.current_city) && _vm.is_loaded_location) ? _c('div', {
    staticClass: "select_city_dialog"
  }, [_c('div', {
    staticClass: "dialog_content"
  }, [(_vm.show_select_dialog == 2) ? _c('p', [_vm._v("哇呜，当前城市未开通班车哦")]) : _c('p', [_vm._v("哇呜，暂时定位不到当前城市")]), _vm._v(" "), (_vm.show_select_dialog == 2) ? _c('a', {
    staticClass: "redBtn",
    on: {
      "click": function($event) {
        return _vm.jumpPage('/selectCity')
      }
    }
  }, [_vm._v("切换到其他城市")]) : _c('a', {
    staticClass: "redBtn",
    on: {
      "click": function($event) {
        return _vm.jumpPage('/selectCity')
      }
    }
  }, [_vm._v("手动选择城市")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "0",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "scene_nav_box"
  }, [_c('div', {
    staticClass: "usercenter_btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeDrawerShow(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon-user-center-btn opt_icon_user"
  }), _vm._v(" "), (_vm.new_message) ? _c('b', {
    staticClass: "new_message"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "view-city",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.jumpPage('/selectCity')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.current_city || '无定位'))]), _vm._v(" "), _c('span', {
    staticClass: "icon opt_icon_arrow"
  })])]), _vm._v(" "), (_vm.view_type === 'address') ? _c('notice', {
    attrs: {
      "position": "1"
    },
    on: {
      "noticed": _vm.showNotice
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "view-commuter"
  }, [(_vm.view_type === 'address') ? _c('commute-address', {
    attrs: {
      "show_notice": _vm.is_show_notice
    }
  }) : _vm._e(), _vm._v(" "), (_vm.view_type === 'code') ? _c('commute-code') : _vm._e()], 1), _vm._v(" "), (_vm.last_feedback_message) ? [_c('div', {
    staticClass: "view-feedback-message",
    class: _vm.show_last_feedback_message ? 'active' : ''
  }, [_c('div', {
    staticClass: "feedback-message",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toFeedbackDetail.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "message-tips"
  }, [_c('span', {
    staticClass: "message-tips-title"
  }, [_vm._v(_vm._s(_vm.last_feedback_title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.last_feedback_message))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-message-control"
  }, [_vm._v("查看")])])])] : _vm._e()], 2), _vm._v(" "), _c('confirm', {
    attrs: {
      "is_show": _vm.show_logout_dialog,
      "title": "确定要退出登录吗？",
      "is_logout": true,
      "phone": _vm.user_real_phone,
      "leftContent": "再想想",
      "rightContent": "确认"
    },
    on: {
      "confirm": _vm.logout,
      "cancel": function($event) {
        _vm.show_logout_dialog = !_vm.show_logout_dialog
      }
    }
  }), _vm._v(" "), _c('confirm', {
    attrs: {
      "is_show": (!!_vm.location_dialog_type && _vm.is_loaded_location),
      "title": "",
      "is_logout": false,
      "phone": true,
      "leftContent": "否",
      "rightContent": "是"
    },
    on: {
      "confirm": function($event) {
        return _vm.jumpPage('/selectCity')
      },
      "cancel": _vm.setCacheCity
    }
  }, [_c('div', {
    staticClass: "confirm_content_text"
  }, [_vm._v("您的定位功能未打开，目前所定位城市为" + _vm._s(_vm.cacheCity) + "，是否手动定位城市？")])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show && _vm.notice) ? _c('div', {
    staticClass: "page-notice"
  }, [_c('div', {
    staticClass: "content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.jumpNotice.apply(null, arguments)
      }
    }
  }, [_vm._v("[通知] " + _vm._s(_vm.notice))]), _vm._v(" "), _c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeNotice.apply(null, arguments)
      }
    }
  }, [_vm._v("x")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_loading),
      expression: "is_loading"
    }],
    staticClass: "globalLoading"
  }, [_vm._m(0)]), _vm._v(" "), _c('router-view', {
    attrs: {
      "title": _vm.title
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(497)
    }
  })])
}]}

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commute_address"
  }, [_c('div', {
    staticClass: "view-section"
  }, [_c('div', {
    staticClass: "view-search-control"
  }, [_c('div', {
    staticClass: "control-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "title",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.switchSearchType.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("编号查询")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-search"
  }, [_c('div', {
    staticClass: "address border-bottom",
    class: {
      'active': !!_vm.start_str
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.jumpSearchPage('commute_start')
      }
    }
  }, [_vm._v(_vm._s(_vm.start_str || '从哪出发'))]), _vm._v(" "), _c('div', {
    staticClass: "address",
    class: {
      'active': !!_vm.end_str
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.jumpSearchPage('commute_end')
      }
    }
  }, [_vm._v(_vm._s(_vm.end_str || '想去哪儿'))]), _vm._v(" "), _c('div', {
    staticClass: "btn-change",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.exchangeAddress.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "icon opt_icon_change"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "view-btn-control"
  }, [_c('div', {
    staticClass: "btn-opt-common",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickSearch.apply(null, arguments)
      }
    }
  }, [_vm._v("查询班车")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_login),
      expression: "is_login"
    }],
    staticClass: "view-section"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("收藏线路")])])]), _vm._v(" "), _c('div', {
    ref: "commute_list",
    staticClass: "wrap-view-list",
    style: ({
      'height': _vm.list_height + 'px'
    }),
    on: {
      "scroll": _vm.listScroll
    }
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "bottom-method": _vm.loadBottom,
      "bottom-all-loaded": _vm.all_search_loaded,
      "autoFill": false
    }
  }, [_c('div', {
    staticClass: "view-list"
  }, [_vm._l((_vm.search_list), function(line) {
    return (_vm.search_list.length > 0) ? [_c('div', {
      staticClass: "list-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.linkDetail(line)
        }
      }
    }, [_c('div', {
      staticClass: "item-top"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(line.line_code || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "title title-right"
    }, [_vm._v(_vm._s(line.shift_name))])]), _vm._v(" "), _c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "site"
    }, [_c('span', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "wrap-dot"
    }, [_c('span', {
      staticClass: "icon-label icon_opt_up_site",
      staticStyle: {
        "float": "left",
        "position": "relative",
        "vertical-align": "top",
        "display": "inline-block",
        "padding": "0",
        "margin": "0"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-text"
    }, [_vm._v(_vm._s(line.start_station || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "content-right content-label"
    }, [(line.shuttle_type === '下班') ? _c('span', {
      staticClass: "opt_label_workoff"
    }) : _vm._e(), _vm._v(" "), (line.shuttle_type === '上班') ? _c('span', {
      staticClass: "opt_label_workon"
    }) : _vm._e(), _vm._v(" "), (line.shuttle_type === '晚班') ? _c('span', {
      staticClass: "opt_label_worklate"
    }) : _vm._e(), _vm._v(" "), (line.shuttle_type === '穿梭车') ? _c('span', {
      staticClass: "opt_label_shutter"
    }) : _vm._e(), _vm._v(" "), (line.shuttle_type === '接驳车') ? _c('span', {
      staticClass: "opt_label_feeder"
    }) : _vm._e(), _vm._v(" "), (line.shuttle_type === '预约休息日班线') ? _c('span', {
      staticClass: "opt_label_rester"
    }) : _vm._e(), _vm._v(" "), (line.operate_flag === 'N') ? _c('span', {
      staticClass: "opt_label_off"
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "site end"
    }, [_c('div', {
      staticClass: "wrap-dot"
    }, [_c('span', {
      staticClass: "icon-label icon_opt_down_site",
      staticStyle: {
        "float": "left",
        "position": "relative",
        "vertical-align": "top",
        "display": "inline-block",
        "padding": "0",
        "margin": "0"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-text"
    }, [_vm._v(_vm._s(line.end_station || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "content-right"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(line.line_price != '0.00' ? '￥' + line.line_price : '免费'))])])])]), _vm._v(" "), _c('div', {
      staticClass: "item-bottom"
    }, [(line.start_time) ? _c('div', {
      staticClass: "text"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v("始发站发车时间：")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(line.start_time))])]) : _vm._e(), _vm._v(" "), (line.time_range) ? _c('div', {
      staticClass: "text"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v("发车时间段：")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(line.time_range))])]) : _vm._e()])])] : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.all_search_loaded && _vm.search_list.length > 0),
      expression: "all_search_loaded && search_list.length > 0"
    }],
    staticClass: "view-tips",
    class: {
      'add-padding-bottom': _vm.is_fixed_bottom
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("暂无更多数据")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.all_search_loaded && _vm.search_list.length === 0 && _vm.is_login),
      expression: "all_search_loaded && search_list.length === 0 && is_login"
    }],
    staticClass: "view-tips"
  }, [_c('div', {
    staticClass: "wrap-icon"
  }, [_c('span', {
    staticClass: "icon icon_no_near_line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("您还没有关注任何线路哦")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_show_logo),
      expression: "is_show_logo"
    }],
    staticClass: "view-search-logo",
    class: {
      'view-fixed': _vm.is_fixed_bottom
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(142),
      "alt": "logo"
    }
  })])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title active"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("地点查询")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })])
}]}

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commute_code"
  }, [_c('div', {
    staticClass: "view-section"
  }, [_c('div', {
    staticClass: "view-search-control"
  }, [_c('div', {
    staticClass: "control-title"
  }, [_c('div', {
    staticClass: "title",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.switchSearchType.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("地点查询")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "control-search"
  }, [_c('div', {
    staticClass: "control-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_text),
      expression: "search_text"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入线路编号或名称"
    },
    domProps: {
      "value": (_vm.search_text)
    },
    on: {
      "focus": function($event) {
        return _vm.inputEve('focus')
      },
      "blur": function($event) {
        return _vm.inputEve('blur')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search_text),
      expression: "search_text"
    }],
    staticClass: "wrap-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clearText.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon_gray_delete"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "view-btn-control"
  }, [_c('div', {
    staticClass: "btn-opt-common",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickSearch.apply(null, arguments)
      }
    }
  }, [_vm._v("查询班车")])])]), _vm._v(" "), _c('div', {
    ref: "commute_list",
    staticClass: "wrap-view-list",
    style: ({
      'height': _vm.list_height + 'px'
    }),
    on: {
      "scroll": _vm.listScroll
    }
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "bottom-method": _vm.loadBottom,
      "bottom-all-loaded": _vm.all_search_loaded,
      "autoFill": false
    }
  }, [_c('div', {
    staticClass: "view-list"
  }, [_vm._l((_vm.search_list), function(line) {
    return (_vm.search_list.length > 0) ? [_c('div', {
      staticClass: "list-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.linkDetail(line)
        }
      }
    }, [_c('div', {
      staticClass: "item-top"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(line.line_code || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "title title-right"
    }, [_vm._v(_vm._s(line.shift_name))])]), _vm._v(" "), _c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "site"
    }, [_c('span', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "wrap-dot"
    }, [_c('span', {
      staticClass: "icon-label icon_opt_up_site",
      staticStyle: {
        "float": "left",
        "position": "relative",
        "vertical-align": "top",
        "display": "inline-block",
        "padding": "0",
        "margin": "0"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-text"
    }, [_vm._v(_vm._s(line.departure_station || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "content-right content-label"
    }, [(line.shuttle_type === '下班') ? _c('span', {
      staticClass: "opt_label_workoff"
    }) : _vm._e(), _vm._v(" "), (line.shuttle_type === '上班') ? _c('span', {
      staticClass: "opt_label_workon"
    }) : _vm._e(), _vm._v(" "), (line.shuttle_type === '晚班') ? _c('span', {
      staticClass: "opt_label_worklate"
    }) : _vm._e(), _vm._v(" "), (line.shuttle_type === '穿梭车') ? _c('span', {
      staticClass: "opt_label_shutter"
    }) : _vm._e(), _vm._v(" "), (line.shuttle_type === '接驳车') ? _c('span', {
      staticClass: "opt_label_feeder"
    }) : _vm._e(), _vm._v(" "), (line.shuttle_type === '预约休息日班线') ? _c('span', {
      staticClass: "opt_label_rester"
    }) : _vm._e(), _vm._v(" "), (line.operate_flag === 'N') ? _c('span', {
      staticClass: "opt_label_off"
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "site end"
    }, [_c('div', {
      staticClass: "wrap-dot"
    }, [_c('span', {
      staticClass: "icon-label icon_opt_down_site",
      staticStyle: {
        "float": "left",
        "position": "relative",
        "vertical-align": "top",
        "display": "inline-block",
        "padding": "0",
        "margin": "0"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-text"
    }, [_vm._v(_vm._s(line.terminal || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "content-right"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(line.line_price != '0.00' ? '￥' + line.line_price : '免费'))])])])]), _vm._v(" "), _c('div', {
      staticClass: "item-bottom"
    }, [(line.start_time) ? _c('div', {
      staticClass: "text"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v("始发站发车时间：")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(line.start_time))])]) : _vm._e(), _vm._v(" "), (line.time_range) ? _c('div', {
      staticClass: "text"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v("发车时间段：")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(line.time_range))])]) : _vm._e()])])] : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.all_search_loaded && _vm.search_list.length > 0),
      expression: "all_search_loaded && search_list.length > 0"
    }],
    staticClass: "view-tips",
    class: {
      'add-padding-bottom': _vm.is_fixed_bottom
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("暂无更多数据")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.all_search_loaded && _vm.search_list.length === 0),
      expression: "all_search_loaded && search_list.length === 0"
    }],
    staticClass: "view-tips"
  }, [_c('div', {
    staticClass: "wrap-icon"
  }, [_c('span', {
    staticClass: "icon no_result"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("未搜索到相关班线")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_show_logo),
      expression: "is_show_logo"
    }],
    staticClass: "view-search-logo",
    class: {
      'view-fixed': _vm.is_fixed_bottom
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(142),
      "alt": "logo"
    }
  })])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title active"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("编号查询")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })])
}]}

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_show),
      expression: "is_show"
    }],
    staticClass: "cancel_order"
  }, [_c('div', {
    staticClass: "cancel_dialog"
  }, [(_vm.is_logout) ? _c('div', {
    staticClass: "logout_title"
  }, [_c('p', [_vm._v("当前账号"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.user_real_phone))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.title))])]) : _c('div', {
    staticClass: "common_title",
    attrs: {
      "name": "header"
    }
  }, [(_vm.title) ? _c('h3', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.subTitle) ? _c('p', [_vm._v(_vm._s(_vm.subTitle))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "common_content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "common_btn",
    attrs: {
      "name": "footer"
    }
  }, [_c('div', {
    class: {
      common_btn_left: _vm.colorType == 'left'
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.leftContent))]), _vm._v(" "), _c('div', {
    class: {
      common_btn_right: _vm.colorType == 'left'
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.rightContent))])])])])
},staticRenderFns: []}

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-drawer"
  }, [_c('div', {
    staticClass: "mask",
    class: _vm.show ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideMask.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "drawer",
    staticClass: "drawer",
    class: [_vm.pos != 'left' ? 'drawer-right' : 'drawer-left', _vm.show ? 'active' : '']
  }, [_vm._t("drawer")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compare */
/* harmony export (immutable) */ __webpack_exports__["a"] = showTips;
/* harmony export (immutable) */ __webpack_exports__["f"] = accAdd;
/* harmony export (immutable) */ __webpack_exports__["k"] = accMul;
/* harmony export (immutable) */ __webpack_exports__["e"] = accSub;
/* unused harmony export autoTextarea */
/* harmony export (immutable) */ __webpack_exports__["g"] = transformDate;
/* harmony export (immutable) */ __webpack_exports__["h"] = restoreDate;
/* harmony export (immutable) */ __webpack_exports__["i"] = formatDay;
/* unused harmony export getDay */
/* harmony export (immutable) */ __webpack_exports__["l"] = getPlusDate;
/* unused harmony export getQueryString */
/* harmony export (immutable) */ __webpack_exports__["b"] = postCnzzData;
/* harmony export (immutable) */ __webpack_exports__["c"] = postBaiduData;
/* harmony export (immutable) */ __webpack_exports__["d"] = postCnzzDataTrack;
/* harmony export (immutable) */ __webpack_exports__["m"] = cutstr;
/* harmony export (immutable) */ __webpack_exports__["j"] = extendObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);




function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var a_components = a.split('.');
  var b_components = b.split('.');

  var len = Math.min(a_components.length, b_components.length);

  for (var i = 0; i < len; i++) {
    if (parseInt(a_components[i]) > parseInt(b_components[i])) {
      return 1;
    }

    if (parseInt(a_components[i]) < parseInt(b_components[i])) {
      return -1;
    }
  }

  if (a_components.length > b_components.length) {
    return 1;
  }
  if (a_components.length < b_components.length) {
    return -1;
  }

  return 0;
}

function showTips(tips, callback) {
  var instance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["Toast"])(tips);
  setTimeout(function () {
    instance.close();
    if (callback) {
      callback();
    }
  }, 2000);
}

function accAdd(arg1, arg2) {
  var r1, r2, m, c;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));
  if (c > 0) {
    var cm = Math.pow(10, c);
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace('.', ''));
      arg2 = Number(arg2.toString().replace('.', '')) * cm;
    } else {
      arg1 = Number(arg1.toString().replace('.', '')) * cm;
      arg2 = Number(arg2.toString().replace('.', ''));
    }
  } else {
    arg1 = Number(arg1.toString().replace('.', ''));
    arg2 = Number(arg2.toString().replace('.', ''));
  }
  return (arg1 + arg2) / m;
}

function accMul(arg1, arg2) {
  var m = 0;
  var s1 = arg1.toString();
  var s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {}
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}

function accSub(arg1, arg2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

function autoTextarea(elem, extra, maxHeight) {
  extra = extra || 0;
  var isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window;
  var isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera');
  var addEvent = function addEvent(type, callback) {
    elem.addEventListener ? elem.addEventListener(type, callback, false) : elem.attachEvent('on' + type, callback);
  };
  var getStyle = elem.currentStyle ? function (name) {
    var val = elem.currentStyle[name];
    if (name === 'height' && val.search(/px/i) !== 1) {
      var rect = elem.getBoundingClientRect();
      return rect.bottom - rect.top - parseFloat(getStyle('paddingTop')) - parseFloat(getStyle('paddingBottom')) + 'px';
    }
    return val;
  } : function (name) {
    return window.getComputedStyle(elem, null)[name];
  };
  var minHeight = parseFloat(getStyle('height'));
  elem.style.resize = 'none';
  var change = function change() {
    var scrollTop;
    var height;
    var padding = 0;
    var style = elem.style;
    if (elem._length === elem.value.length) return;
    elem._length = elem.value.length;
    if (!isFirefox && !isOpera) {
      padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'));
    }
    scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    elem.style.height = minHeight + 'px';
    if (elem.scrollHeight > minHeight) {
      if (maxHeight && elem.scrollHeight > maxHeight) {
        height = maxHeight - padding;
        style.overflowY = 'auto';
      } else {
        height = elem.scrollHeight - padding;
        style.overflowY = 'hidden';
      }
      style.height = height + extra + 'px';
      scrollTop += parseInt(style.height) - elem.currHeight;
      document.body.scrollTop = scrollTop;
      document.documentElement.scrollTop = scrollTop;
      elem.currHeight = parseInt(style.height);
    }
  };
  addEvent('propertychange', change);
  addEvent('input', change);
  addEvent('focus', change);
  change();
}

var timeFormat = function timeFormat(date, fmt) {
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds() };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  }
  return fmt;
};

function transformDate(date) {
  var date_obj = {
    cn_date: date.getMonth() + 1 + '月' + date.getDate() + '日' + '周' + '日一二三四五六'.split('')[date.getDay()],
    time: date.getHours() + ':' + date.getMinutes(),
    week: '周' + '日一二三四五六'.split('')[date.getDay()],
    param: timeFormat(date, 'yyyy/MM/dd hh:mm'),
    date: timeFormat(date, 'yyyy/MM/dd')
  };
  return date_obj;
}

function restoreDate(date, hour, minute) {
  var _now = new Date();
  var _now_month = _now.getMonth() + 1;
  var _now_year = _now.getFullYear();
  var _date = date.slice(0, -3).split('月');
  var _year = _date[0] >= _now_month ? _now_year : _now_year + 1;
  var _hour = hour.slice(0, -1);
  var _minute = minute.slice(0, -1);
  if (_hour.length === 1) {
    _hour = '0' + _hour;
  }
  if (_minute.length === 1) {
    _minute = '0' + _minute;
  }
  return {
    param: _year + '/' + _date[0] + '/' + _date[1] + ' ' + _hour + ':' + _minute,
    date: date.slice(0, -2),
    week: date.slice(-2),
    time: _hour + ':' + _minute
  };
}

function formatDay(date, type) {
  date = date || new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (type === 'line') {
    return year + '-' + month + '-' + day;
  } else {
    if (type === 'year') {
      return year + '年' + month + '月' + day + '日 ' + getDay(date, 'day');
    } else {
      return month + '月' + day + '日';
    }
  }
}

function getDay(date, type) {
  var _list = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  var _listMon = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  var _date = date || new Date();

  if (type === 'day') {
    return _listMon[_date.getDay()];
  } else {
    return _list[_date.getDay()];
  }
}

function getPlusDate(num, dayStr) {
  var _num = parseInt(num) || 0;
  var _limit = _num * 24 * 60 * 60 * 1000;
  var _date = new Date();
  var _times = 0;
  var _startDate = {};
  if (dayStr) {
    _startDate.month = dayStr.substring(5, dayStr.lastIndexOf('-'));
    _startDate.day = dayStr.substring(dayStr.length, dayStr.lastIndexOf('-') + 1);
    _startDate.year = dayStr.substring(0, dayStr.indexOf('-'));
    _times = Date.parse(_startDate.month + '/' + _startDate.day + '/' + _startDate.year) + _limit;
  } else {
    _times = _date.getTime() + _limit;
  }

  return new Date(_times);
}

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r !== null) {
    return unescape(r[2]);
  }
  return null;
}

function postCnzzData(category_id, type_value, label, val) {
  var _href = window.location.href || '';
  var _label = label || 0;
  var _val = parseInt(val) || 0;
  var _isDev = _href.indexOf('apitest') !== -1 || _href.indexOf('localhost') !== -1;
  if (!_isDev) {
    if (category_id && window._czc) {
      try {
        if (_label) {
          if (type_value) {
            window._czc.push(['_trackEvent', category_id, type_value, _label, _val]);
          } else {
            window._czc.push(['_trackEvent', category_id, '点击', _label, _val]);
          }
        } else {
          if (type_value) {
            window._czc.push(['_trackEvent', category_id, type_value]);
          } else {
            window._czc.push(['_trackEvent', category_id, '点击']);
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
}

function postBaiduData(category, action, opt_label, opt_value) {
  var _category = category || '-';
  var _action = action || '-';
  var _opt_label = opt_label || '-';
  var _opt_value = opt_value || 0;
  if (_hmt && _category) {
    _hmt.push(['_trackEvent', _category, _action, _opt_label, _opt_value]);
  }
}

function postCnzzDataTrack(contentUrl, refererUrl) {
  var _href = window.location.href || '';
  var _isDev = _href.indexOf('apitest') !== -1 || _href.indexOf('localhost') !== -1;
  var _contentUrl = '/enterprise/dist' + contentUrl;
  var _refererUrl = 'https://wx.dudubashi.com/enterprise/dist' + refererUrl;
  if (!_isDev) {
    if (contentUrl && window._czc) {
      try {
        window._czc.push(['_trackPageview', _contentUrl, _refererUrl]);
      } catch (e) {
        console.log(e);
      }
    }
  }
}

function cutstr(str, len) {
  var str_length = 0;
  var str_len = 0;
  var str_cut = '';
  str_len = str.length;
  for (var i = 0; i < str_len; i++) {
    var a = str.charAt(i);
    str_length++;
    if (decodeURIComponent(a).length > 4) {
      str_length++;
    }
    if (str_length > len) {
      str_cut = str_cut.concat('...');
      return str_cut;
    } else {
      str_cut = str_cut.concat(a);
    }
  }

  if (str_length <= len) {
    return str;
  }
}

function extendObject(source, deep) {
  function isPlainObject(obj) {
    return obj && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) === 'object' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(obj) === Object.prototype;
  }
  var isArray = Array.isArray || function (object) {
    return object instanceof Array;
  };
  var target = {};
  if (isArray(source)) {
    target = [];
  }
  for (var key in source) {
    if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
      target[key] = extendObject(source[key], deep);
    } else if (source[key] !== undefined) {
      if (isArray(source)) {
        target.push(source[key]);
      } else {
        target[key] = source[key];
      }
    }
  }

  return target;
}

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return UPDATE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return UPDATE_DIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return UPDATE_BACK_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return UPDATE_PAGE_FROM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UPDATE_WIN_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return UPDATE_IS_TRIGGER_COLLECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return UPDATE_IS_TRIGGER_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return UPDATE_COMMON_CACHE_VAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPDATE_USER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPDATE_USER_PHONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPDATE_USER_AVATAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_USER_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_USER_NICKNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UPDATE_USER_BASE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_CURRENT_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_LOCATION_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_LOCATION_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_HOT_CITY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_OPEN_CITY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_CURRENT_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_HISTORY_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_LOCATION_TIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_IS_LOADED_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_ENTRY_HREF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_ENTERPRISE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPDATE_HOME_PAGE_NAV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return UPDATE_CURRENT_HOME_PAGE_NAV_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_CURRENT_HOME_PAGE_NAV_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UPDATE_CONFIG_COMPANY_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return UPDATE_NEW_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_LINK_PARAM_CACHE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_CHECK_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return UPDATE_CHECK_LINE; });

var UPDATE_LOADING = 'UPDATE_LOADING';

var UPDATE_DIRECTION = 'UPDATE_DIRECTION';

var UPDATE_BACK_PATH = 'UPDATE_BACK_PATH';

var UPDATE_PAGE_FROM = 'UPDATE_PAGE_FROM';

var UPDATE_WIN_HEIGHT = 'UPDATE_WIN_HEIGHT';

var UPDATE_IS_TRIGGER_COLLECT = 'UPDATE_IS_TRIGGER_COLLECT';

var UPDATE_IS_TRIGGER_SEARCH = 'UPDATE_IS_TRIGGER_SEARCH';

var UPDATE_COMMON_CACHE_VAL = 'UPDATE_COMMON_CACHE_VAL';

var UPDATE_USER_ID = 'UPDATE_USER_ID';

var UPDATE_USER_PHONE = 'UPDATE_USER_PHONE';

var UPDATE_USER_AVATAR = 'UPDATE_USER_AVATAR';

var SET_USER_TOKEN = 'SET_USER_TOKEN';

var UPDATE_USER_NICKNAME = 'UPDATE_USER_NICKNAME';

var UPDATE_USER_BASE_INFO = 'UPDATE_USER_BASE_INFO';

var UPDATE_CURRENT_CITY = 'UPDATE_CURRENT_CITY';
var UPDATE_LOCATION_CITY = 'UPDATE_LOCATION_CITY';
var UPDATE_LOCATION = 'UPDATE_LOCATION';
var UPDATE_LOCATION_ADDRESS = 'UPDATE_LOCATION_ADDRESS';
var UPDATE_HOT_CITY_LIST = 'UPDATE_HOT_CITY_LIST';
var UPDATE_OPEN_CITY_LIST = 'UPDATE_OPEN_CITY_LIST';
var UPDATE_CURRENT_LOCATION = 'UPDATE_CURRENT_LOCATION';
var UPDATE_HISTORY_ADDRESS = 'UPDATE_HISTORY_ADDRESS';
var UPDATE_LOCATION_TIPS = 'UPDATE_LOCATION_TIPS';

var UPDATE_IS_LOADED_LOCATION = 'UPDATE_IS_LOADED_LOCATION';

var UPDATE_ENTRY_HREF = 'UPDATE_ENTRY_HREF';

var SET_ENTERPRISE_ID = 'SET_ENTERPRISE_ID';
var UPDATE_HOME_PAGE_NAV = 'UPDATE_HOME_PAGE_NAV';
var UPDATE_CURRENT_HOME_PAGE_NAV_ID = 'UPDATE_CURRENT_HOME_PAGE_NAV_ID';
var UPDATE_CURRENT_HOME_PAGE_NAV_INDEX = 'UPDATE_CURRENT_HOME_PAGE_NAV_INDEX';
var UPDATE_CONFIG_COMPANY_ADDRESS = 'UPDATE_CONFIG_COMPANY_ADDRESS';

var UPDATE_NEW_MESSAGE = 'UPDATE_NEW_MESSAGE';

var UPDATE_LINK_PARAM_CACHE = 'UPDATE_LINK_PARAM_CACHE';

var UPDATE_CHECK_ADDRESS = 'UPDATE_CHECK_ADDRESS';

var UPDATE_CHECK_LINE = 'UPDATE_CHECK_LINE';

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

module.exports = window.BMapLib;

/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequestCommonResponse", function() { return RequestCommonResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNotice", function() { return getNotice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNoticeDetail", function() { return getNoticeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchLine", function() { return searchLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "similarLine", function() { return similarLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "organizeLine", function() { return organizeLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnopenLineInfo", function() { return getUnopenLineInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBusLocation", function() { return getBusLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "collectBusLine", function() { return collectBusLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendFeedback", function() { return sendFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendFeedbackEnt", function() { return sendFeedbackEnt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEvaluateInfo", function() { return getEvaluateInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendEvaluateInfo", function() { return sendEvaluateInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserCollectLineInfo", function() { return getUserCollectLineInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserCustomLineInfo", function() { return getUserCustomLineInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMyMessage", function() { return getMyMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMessageDetail", function() { return getMessageDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeAllMessage", function() { return removeAllMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appleNewLine", function() { return appleNewLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSiteInfo", function() { return getSiteInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNearSites", function() { return getNearSites; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFeedbackDetail", function() { return getFeedbackDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMotors", function() { return getMotors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEvaluateDetail", function() { return getEvaluateDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "evaluatePoint", function() { return evaluatePoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderNav", function() { return getOrderNav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderList", function() { return getOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderDetail", function() { return getOrderDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelOrder", function() { return cancelOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkTicket", function() { return checkTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLineQrCode", function() { return getLineQrCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canEnterEnterprise", function() { return canEnterEnterprise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCheckResult", function() { return getCheckResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBusPriceDesc", function() { return getBusPriceDesc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBusTicketInfo", function() { return getBusTicketInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBusCardInfo", function() { return getBusCardInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "payCard", function() { return payCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "payTicket", function() { return payTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canApplyMoreBus", function() { return canApplyMoreBus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkHasUnpayTicket", function() { return checkHasUnpayTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBusContactPhone", function() { return getBusContactPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRefundCalendar", function() { return getRefundCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "refundTickets", function() { return refundTickets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ifOrderCanCheck", function() { return ifOrderCanCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUsefulTicket", function() { return getUsefulTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCheckedRecord", function() { return getCheckedRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCheckAddressList", function() { return getCheckAddressList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchLineCode", function() { return searchLineCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchLineAddress", function() { return searchLineAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchCollectLines", function() { return searchCollectLines; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOpenLines", function() { return getOpenLines; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTrackLog", function() { return updateTrackLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postAnalyzeData", function() { return postAnalyzeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFeedbackType", function() { return getFeedbackType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLastFeedbackMessage", function() { return getLastFeedbackMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_util__ = __webpack_require__(56);



var baseUrl = 'https://wx.dudubashi.com';
var RequestCommonResponse = function RequestCommonResponse(options) {
  var _code = options.res.result;
  if (_code === '0005') {
    options.rootState.common.need_jump_login = true;
    setTimeout(function () {
      options.rootState.common.need_jump_login = false;
    }, 500);
  } else if (_code === '0000') {
    options.successCallback(options.res || {});
  } else {
    options.failCallback(options.res || {});
  }
};

var getNotice = function getNotice(_ref, params) {
  var commit = _ref.commit,
      state = _ref.state,
      rootState = _ref.rootState;

  params.enterprise_id = rootState.config.enterprise_id;
  params.city_name = rootState.address.current_city || rootState.address.location_city || '';
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/system/notice/get_urgent_message').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getNoticeDetail = function getNoticeDetail(_ref2, notice_id) {
  var commit = _ref2.commit,
      state = _ref2.state,
      rootState = _ref2.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/system/notice/urgent_message_detail').send({
      notice_id: notice_id
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var searchLine = function searchLine(_ref3, params) {
  var commit = _ref3.commit,
      state = _ref3.state,
      rootState = _ref3.rootState;

  var _params = params.query_params;
  _params.with_walk_distance = 1;
  _params.enterprise_id = rootState.config.enterprise_id;
  _params.city = rootState.address.current_city || rootState.address.location_city;
  if (rootState.userInfo.user_id) {
    _params.user_id = rootState.userInfo.user_id;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/api/search_new').send(_params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var similarLine = function similarLine(_ref4, params) {
  var commit = _ref4.commit,
      state = _ref4.state,
      rootState = _ref4.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var _params = params || {};
    _params.enterprise_id = rootState.config.enterprise_id;
    _params.user_id = rootState.userInfo.user_id || '';
    _params.city_name = _params.city_name = rootState.address.current_city || rootState.address.location_city;
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/suggest/similar_line').send(_params).type('form').end(function (err, res) {
      if (err) {
        reject({
          result: '0000',
          info: '当前网络不可用，请稍后重试～'
        });
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var organizeLine = function organizeLine(_ref5, params) {
  var commit = _ref5.commit,
      state = _ref5.state,
      rootState = _ref5.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var _params = params || {};
    _params.enterprise_id = rootState.config.enterprise_id;
    _params.user_id = rootState.userInfo.user_id || '';
    _params.city_name = _params.city_name = rootState.address.current_city || rootState.address.location_city;
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/suggest/add_line').send(_params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getUnopenLineInfo = function getUnopenLineInfo(_ref6, params) {
  var commit = _ref6.commit,
      state = _ref6.state,
      rootState = _ref6.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var _params = {
      user_id: rootState.userInfo.user_id,
      line_id: params.line_id,
      enterprise_id: rootState.config.enterprise_id
    };
    if (params.type !== undefined) {
      _params.type = params.type;
    }
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/suggest/line_info').send(_params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getBusLocation = function getBusLocation(_ref7, line_id) {
  var commit = _ref7.commit,
      state = _ref7.state,
      rootState = _ref7.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/info/line_bus_locations').send({
      'line_id': line_id
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        if (res.data && res.data.length) {
          res.data.forEach(function (element) {
            if (element.gps_time) {
              var date1 = new Date(element.gps_time);
              var date2 = new Date();
              var diff = Math.abs(date2 - date1);
              var diffInSeconds = diff / 1000;
              element.gps_time_show_line = diffInSeconds;
              console.log('diffInSeconds--->', diffInSeconds);
            }
          });
        }
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var collectBusLine = function collectBusLine(_ref8, line_id) {
  var commit = _ref8.commit,
      state = _ref8.state,
      rootState = _ref8.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/info/line_collect').send({
      'line_id': line_id
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            commit('UPDATE_IS_TRIGGER_COLLECT', true);
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var sendFeedback = function sendFeedback(_ref9, params) {
  var commit = _ref9.commit,
      state = _ref9.state,
      rootState = _ref9.rootState;

  params.enterprise_id = rootState.config.enterprise_id;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/users/suggest/suggest_report').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var sendFeedbackEnt = function sendFeedbackEnt(_ref10, params) {
  var commit = _ref10.commit,
      state = _ref10.state,
      rootState = _ref10.rootState;

  params.enterprise_id = rootState.config.enterprise_id;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/users/suggest/suggest_report_huawei').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getEvaluateInfo = function getEvaluateInfo(_ref11, line_id) {
  var commit = _ref11.commit,
      state = _ref11.state,
      rootState = _ref11.rootState;

  var _params = {
    line_id: line_id
  };
  if (rootState.config.enterprise_id) {
    _params.enterprise_id = rootState.config.enterprise_id;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/info/get_evaluate_info').send(_params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var sendEvaluateInfo = function sendEvaluateInfo(_ref12, params) {
  var commit = _ref12.commit,
      state = _ref12.state,
      rootState = _ref12.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/info/evaluate_line').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getUserCollectLineInfo = function getUserCollectLineInfo(_ref13, params) {
  var commit = _ref13.commit,
      state = _ref13.state,
      rootState = _ref13.rootState;

  if (rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/info/get_collect_line').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getUserCustomLineInfo = function getUserCustomLineInfo(_ref14, params) {
  var commit = _ref14.commit,
      state = _ref14.state,
      rootState = _ref14.rootState;

  if (rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/suggest/get_suggest_lines').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getMyMessage = function getMyMessage(_ref15) {
  var commit = _ref15.commit,
      state = _ref15.state,
      rootState = _ref15.rootState;

  var params = {};
  if (rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/users/message/message_list').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getMessageDetail = function getMessageDetail(_ref16, message_id) {
  var commit = _ref16.commit,
      state = _ref16.state,
      rootState = _ref16.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/users/message/message_detail').send({
      message_id: message_id,
      user_id: rootState.userInfo.user_id
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var removeAllMessage = function removeAllMessage(_ref17, message_id) {
  var commit = _ref17.commit,
      state = _ref17.state,
      rootState = _ref17.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/users/message/message_delete').send({
      user_id: rootState.userInfo.user_id
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var appleNewLine = function appleNewLine(_ref18, params) {
  var commit = _ref18.commit,
      state = _ref18.state,
      rootState = _ref18.rootState;

  if (rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/suggest/apply_line').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getSiteInfo = function getSiteInfo(_ref19, params) {
  var commit = _ref19.commit,
      state = _ref19.state,
      rootState = _ref19.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/api/get_site').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getNearSites = function getNearSites(_ref20, params) {
  var commit = _ref20.commit,
      state = _ref20.state,
      rootState = _ref20.rootState;

  if (rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id;
  }
  if (rootState.config.home_page_nav_id) {
    params.enterprise_nav_id = rootState.config.home_page_nav_id;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/enterprise/get_near_sites').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getFeedbackDetail = function getFeedbackDetail(_ref21, params) {
  var commit = _ref21.commit,
      state = _ref21.state,
      rootState = _ref21.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/users/suggest/detail').send({
      user_id: params.user_id || '',
      suggest_id: params.suggest_id || '',
      suggest_pid: params.suggest_pid || ''
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getMotors = function getMotors(_ref22, enterprise_id) {
  var commit = _ref22.commit,
      state = _ref22.state,
      rootState = _ref22.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/enterprise/get_motors').send({
      enterprise_id: enterprise_id
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getEvaluateDetail = function getEvaluateDetail(_ref23, evaluate_id) {
  var commit = _ref23.commit,
      state = _ref23.state,
      rootState = _ref23.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/info/evaluate_detail').send({
      evaluate_id: evaluate_id
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var evaluatePoint = function evaluatePoint(_ref24, param) {
  var commit = _ref24.commit,
      state = _ref24.state,
      rootState = _ref24.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/users/suggest/evaluate').send({
      suggest_id: param.id,
      level: param.level
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getOrderNav = function getOrderNav(_ref25, params) {
  var commit = _ref25.commit,
      state = _ref25.state,
      rootState = _ref25.rootState;

  var _params = {};
  if (rootState.config.enterprise_id) {
    _params.enterprise_id = rootState.config.enterprise_id;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/enterprise/get_order_navs').send(_params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getOrderList = function getOrderList(_ref26, params) {
  var commit = _ref26.commit,
      state = _ref26.state,
      rootState = _ref26.rootState;

  if (rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id;
  }

  params.pay_status = -1;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/enterprise/get_order_list').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getOrderDetail = function getOrderDetail(_ref27, order_num) {
  var commit = _ref27.commit,
      state = _ref27.state,
      rootState = _ref27.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/order/ticket/order_detail_new').send({
      order_num: order_num
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var cancelOrder = function cancelOrder(_ref28, params) {
  var commit = _ref28.commit,
      state = _ref28.state,
      rootState = _ref28.rootState;

  params.user_id = rootState.userInfo.user_id;
  params.line_type = 8;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/order/ticket/cancel_commuter_order').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var checkTicket = function checkTicket(_ref29, params) {
  var commit = _ref29.commit,
      state = _ref29.state,
      rootState = _ref29.rootState;

  params.user_id = rootState.userInfo.user_id;
  if (rootState.address.current_pos) {
    params.lng = rootState.address.current_pos.lng;
    params.lat = rootState.address.current_pos.lat;
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/card/verify/commuter_ticket_check').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getLineQrCode = function getLineQrCode(_ref30, params) {
  var commit = _ref30.commit,
      state = _ref30.state,
      rootState = _ref30.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/card/verify/get_qr_code').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var canEnterEnterprise = function canEnterEnterprise(_ref31, enterprise_id) {
  var commit = _ref31.commit,
      state = _ref31.state,
      rootState = _ref31.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/enterprise/can_enter_enterprise').send({
      enterprise_id: enterprise_id
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getCheckResult = function getCheckResult(_ref32, params) {
  var commit = _ref32.commit,
      state = _ref32.state,
      rootState = _ref32.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/card/verify/get_check_info').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getBusPriceDesc = function getBusPriceDesc(_ref33, line_id) {
  var commit = _ref33.commit,
      state = _ref33.state,
      rootState = _ref33.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/order/line/get_commuter_ticket_info').send({
      line_id: line_id
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getBusTicketInfo = function getBusTicketInfo(_ref34, line_id) {
  var commit = _ref34.commit,
      state = _ref34.state,
      rootState = _ref34.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/order/line/get_ticket_info').send({
      line_id: line_id,
      user_id: rootState.userInfo.user_id
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getBusCardInfo = function getBusCardInfo(_ref35, line_id) {
  var commit = _ref35.commit,
      state = _ref35.state,
      rootState = _ref35.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/info/get_line_card').send({
      line_id: line_id
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var payCard = function payCard(_ref36, params) {
  var commit = _ref36.commit,
      state = _ref36.state,
      rootState = _ref36.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/order/commuter/buy').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var payTicket = function payTicket(_ref37, params) {
  var commit = _ref37.commit,
      state = _ref37.state,
      rootState = _ref37.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/order/ticket/buy').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var canApplyMoreBus = function canApplyMoreBus(_ref38, params) {
  var commit = _ref38.commit,
      state = _ref38.state,
      rootState = _ref38.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/info/apply_bus').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var checkHasUnpayTicket = function checkHasUnpayTicket(_ref39, params) {
  var commit = _ref39.commit,
      state = _ref39.state,
      rootState = _ref39.rootState;

  params = params || {};
  params.user_id = rootState.userInfo.user_id;
  params.enterprise_id = rootState.config.enterprise_id;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/order/ticket/check_no_pay_order').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getBusContactPhone = function getBusContactPhone(_ref40, params) {
  var commit = _ref40.commit,
      state = _ref40.state,
      rootState = _ref40.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/order/line/get_contact_phone').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getRefundCalendar = function getRefundCalendar(_ref41, order_num) {
  var commit = _ref41.commit,
      state = _ref41.state,
      rootState = _ref41.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/order/ticket/get_cancel_calendar').send({
      user_id: rootState.userInfo.user_id,
      order_num: order_num
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var refundTickets = function refundTickets(_ref42, params) {
  var commit = _ref42.commit,
      state = _ref42.state,
      rootState = _ref42.rootState;

  params.user_id = rootState.userInfo.user_id;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/order/ticket/refund_new').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var ifOrderCanCheck = function ifOrderCanCheck(_ref43, params) {
  var commit = _ref43.commit,
      state = _ref43.state,
      rootState = _ref43.rootState;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/order/ticket/can_order_check').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getUsefulTicket = function getUsefulTicket(_ref44, params) {
  var commit = _ref44.commit,
      state = _ref44.state,
      rootState = _ref44.rootState;

  params = params || {};
  if (rootState.config && rootState.config.enterprise_id) {
    params.enterprise_id = rootState.config.enterprise_id;
  }
  if (rootState.address.current_pos) {
    params.lng = rootState.address.current_pos.lng;
    params.lat = rootState.address.current_pos.lat;
  }

  params.order_type = 0;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/line/enterprise/get_available_orders').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getCheckedRecord = function getCheckedRecord(_ref45, params) {
  var commit = _ref45.commit,
      state = _ref45.state,
      rootState = _ref45.rootState;

  params.enterprise_id = rootState.config.enterprise_id;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/users/order/get_check_records').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getCheckAddressList = function getCheckAddressList(_ref46, params) {
  var commit = _ref46.commit,
      state = _ref46.state,
      rootState = _ref46.rootState;

  params.enterprise_id = rootState.config.enterprise_id;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/huawei/line/search_location').send(params).type('form').end(function (err, res) {
      if (err) {
        reject({
          result: '0000',
          info: '当前网络不可用，请稍后重试～'
        });
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var searchLineCode = function searchLineCode(_ref47, params) {
  var commit = _ref47.commit,
      state = _ref47.state,
      rootState = _ref47.rootState;

  if (rootState.address.current_city || rootState.address.location_city) {
    params.city_name = rootState.address.current_city || rootState.address.location_city;
  }
  params.enterprise_id = rootState.config.enterprise_id;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/huawei/line/search_line_by_code').send(params).type('form').end(function (err, res) {
      if (err) {
        reject({
          result: '0000',
          info: '当前网络不可用，请稍后重试～'
        });
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var searchLineAddress = function searchLineAddress(_ref48, params) {
  var commit = _ref48.commit,
      state = _ref48.state,
      rootState = _ref48.rootState;

  params.enterprise_id = rootState.config.enterprise_id || '';
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/huawei/line/search_line_by_location').send(params).type('form').end(function (err, res) {
      if (err) {
        reject({
          result: '0000',
          info: '当前网络不可用，请稍后重试～'
        });
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
            commit('UPDATE_IS_TRIGGER_SEARCH', false);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var searchCollectLines = function searchCollectLines(_ref49, params) {
  var commit = _ref49.commit,
      state = _ref49.state,
      rootState = _ref49.rootState;

  params.enterprise_id = rootState.config.enterprise_id || '';
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/huawei/line/my_collect_lines').send(params).type('form').end(function (err, res) {
      if (err) {
        reject({
          result: '0000',
          info: '当前网络不可用，请稍后重试～'
        });
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getOpenLines = function getOpenLines(_ref50, params) {
  var commit = _ref50.commit,
      state = _ref50.state,
      rootState = _ref50.rootState;

  params.enterprise_id = rootState.config.enterprise_id || '';
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/huawei/line/unopen_lines').send(params).type('form').end(function (err, res) {
      if (err) {
        reject({
          result: '0000',
          info: '当前网络不可用，请稍后重试～'
        });
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var updateTrackLog = function updateTrackLog(_ref51, params) {
  var commit = _ref51.commit,
      state = _ref51.state,
      rootState = _ref51.rootState;

  params.enterprise_id = rootState.config.enterprise_id || '';
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/huawei/line/track_log').send(params).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var postAnalyzeData = function postAnalyzeData(_ref52, params) {
  var commit = _ref52.commit,
      state = _ref52.state,
      rootState = _ref52.rootState;

  var _params = params || {};
  if (!_params.opt_label) {
    _params.opt_value = rootState.userInfo.user_id || '';
    if (rootState.userInfo.user_id) {
      _params.opt_label = '登录';
    } else {
      _params.opt_label = '未登录';
    }
  }
  if (_params.type === 'pv') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_js_util__["c" /* postBaiduData */])(_params.category, _params.action, _params.opt_label, _params.opt_value || '');
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_js_util__["c" /* postBaiduData */])(_params.category, _params.action, _params.opt_label, _params.opt_value || '');
  }
};

var getFeedbackType = function getFeedbackType(_ref53, params) {
  var commit = _ref53.commit,
      state = _ref53.state,
      rootState = _ref53.rootState;

  var _id = params && params.id;
  var _params = params || {};
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/users/suggest/get_suggest_type_list').send({
      enterprise_id: rootState.config.enterprise_id || _params.enterprise_id || '',
      suggest_id: _id || ''
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

var getLastFeedbackMessage = function getLastFeedbackMessage(_ref54, params) {
  var commit = _ref54.commit,
      state = _ref54.state,
      rootState = _ref54.rootState;

  var _id = params && params.id;
  var _params = params || {};
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(baseUrl + '/index.php/users/message/get_last_suggest_reply_message').send({
      enterprise_id: rootState.config.enterprise_id || _params.enterprise_id || '',
      suggest_id: _id || ''
    }).type('form').end(function (err, res) {
      if (err) {
        throw err;
      } else {
        res = JSON.parse(res.text);
        RequestCommonResponse({
          'rootState': rootState,
          'res': res,
          successCallback: function successCallback(res) {
            resolve(res);
          },
          failCallback: function failCallback(res) {
            reject(res);
          }
        });
      }
    });
  });
};

/***/ })

},[214]);


// WEBPACK FOOTER //
// static/js/app.aa3a4f674567225717b6.js